import { getSourceTypeId, handleForbiddenResponse, handleOfflineResponse } from 'utilities'
import Cookies from 'js-cookie'
import { setAuthTimeout } from './Auth/AuthActions'
import { invalidateAllCategoryCaches } from './components/Search/SearchActions'
import { invalidateAllCategoryCaches as invalidateAllWorkQueueCategoryCaches } from './components/MyWorkQueue/MyWorkQueueActions'
import { invalidateAllCategoryCaches as invalidateAllMyRecordsCategoryCaches } from './components/MyRecords/MyRecordsActions'
import store from './store'
import utf8 from 'utf8'

export const DEV_PORT = 53013
export const DEV_API_URL = process.env.DEV_API_URL
export const USE_ENTITY_SEARCH_ENDPOINT = process.env.USE_ENTITY_SEARCH_ENDPOINT
export const USE_ENTITY_FRAMEWORK = process.env.USE_ENTITY_FRAMEWORK
export const BASE_URL = DEV_API_URL
  ? DEV_API_URL
  : process.env.API_PROXY
  ? 'http://' + process.env.PROXY_URL
  : process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
  ? `http://localhost:${DEV_PORT}`
  : ''

// const setAppError = (error) => ({
//   type: "SET_APP_ERROR",
//   errorType: 'danger',
//   error
// })

// const handleErrors = (response) => (
//   new Promise((resolve, reject) => {
//     if(response.ok){
//       resolve(response)
//     }else{
//       // store.dispatch(setAppError())
//       reject(response)
//     }
//   })
// )
//
// const catchErrors = response => {
//   store.dispatch(setAppError("It looks we can't reach the server right now. Check your internet connection and try again later."))
//   if(process.env.NODE_ENV !== "test"){console.error(response)}
// }

const handleCustomHeaders = (response) => {
  try {
    // Handle authorization headers
    let timeout = response.headers.get('session-timeout')
    if (timeout) {
      timeout = parseInt(timeout, 10)
      if (timeout) {
        setAuthTimeout(timeout)
      }
    }

    // Handle search cache invalidation
    let invalidateSearchCache = response.headers.get('invalidate-search-cache')
    if (invalidateSearchCache) {
      if (invalidateSearchCache === 'all') {
        invalidateAllCategoryCaches()(store.dispatch, store.getState)
      }
    }

    // Handle work queue cache invalidation
    let invalidateWorkQueueCache = response.headers.get('invalidate-work-queue-cache')
    if (invalidateWorkQueueCache) {
      if (invalidateWorkQueueCache === 'all') {
        invalidateAllWorkQueueCategoryCaches()(store.dispatch, store.getState)
      }
    }

    // Handle work queue cache invalidation
    let invalidateMyRecordsCache = response.headers.get('invalidate-my-records-cache')
    if (invalidateMyRecordsCache) {
      if (invalidateMyRecordsCache === 'all') {
        invalidateAllMyRecordsCategoryCaches()(store.dispatch, store.getState)
      }
    }
  } catch (e) {
    console.error(e)
  }
}

const parseResponse = (response) =>
  new Promise((resolve, reject) => {
    const contentType = response.headers.get('content-type') || ''
    const responseIsJson = contentType.toLowerCase().includes('application/json')

    handleCustomHeaders(response)

    if (response.status === 403) {
      // console.log(...response.headers)
      const isGateway = !response.headers.has('session-timeout')
      handleForbiddenResponse(isGateway, response.url)
    }

    if (response.status === 503) {
      handleOfflineResponse()
    }

    if (response.status === 204) {
      response.text().then(resolve)
      return
    }

    if (response.status === 200) {
      if (responseIsJson) {
        response.json().then(resolve)
        return
      } else {
        response.text().then(resolve)
        return
      }
    }

    if (response.status !== 200) {
      //       console.warn(
      // `The requested route responded with an unhandled status: \
      // ${response.status} (${response.statusText}). If this is unexpected, \
      // check the controller method for route: ${response.url}.`
      //       )
      if (responseIsJson) {
        response.text().then((text) => {
          try {
            const parsed = JSON.parse(text)
            if (response.ok) {
              resolve(parsed)
            } else {
              reject(parsed)
            }
          } catch (e) {
            console.warn(
              `The server responded with a content-type of "${contentType}" \
but json parsing failed. The response will be returned as \
plain text. For performance reasons, if the response body is \
not json, content-type should be set to "text/plain". Check \
the controller method for route: ${response.url}`
            )
            reject(text)
          }
        })
        return
      } else {
        response.text().then((text) => {
          if (response.ok) {
            resolve(text)
          } else {
            reject(text)
          }
        })
      }
    }
  })

const fetchAndCatch = (props, callback, errorCallback) => {
  let auth = {}
  let AUTH = localStorage.getItem('USER_AUTHENTICATION')
  auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {}
  // console.log(auth)
  // console.log({
  //   method: props.method,
  //   headers: new Headers({
  //     'content-type': props.contentType ? props.contentType : 'application/json',
  //     Authorization: auth.ID,
  //     ...props.headers,
  //   }),
  //   body: props.body ? props.body : JSON.stringify({}),
  // })

  let specialUserId = Cookies.get('special-user-id')

  if (!auth.ID) {
    console.debug('unable to find user from local storage. Checking cookies...')

    if (specialUserId && specialUserId !== '') {
      console.debug('user found in cookies. attaching credentials')
      auth.ID = specialUserId
    }
  } else if (specialUserId && specialUserId !== '' && auth.ID !== specialUserId) {
    console.debug(`overwritting auth.ID with MI Login value ${specialUserId}`)
    auth.ID = specialUserId
  }

  let request
  switch (props.method) {
    case 'PUT':
    case 'POST':
    case 'DELETE':
    case 'PATCH':
      request = {
        method: props.method,
        headers: new Headers({
          'content-type': props.contentType ? props.contentType : 'application/json',
          Authorization: auth.ID,
          ...props.headers,
        }),
        body: props.body ? props.body : JSON.stringify({}),
      }
      break
    case 'GET':
    default:
      request = {
        method: 'GET',
        headers: new Headers({
          Authorization: auth.ID,
          ...props.headers,
        }),
      }
  }
  if (props.cookies) {
    request.credentials = 'include'
  }
  if (props.getSignal && window.AbortController) {
    const controller = new AbortController()
    request.signal = controller.signal
    props.getSignal(controller)
  }
  fetch(`${BASE_URL}${props.url}`, request)
    // .then(handleErrors)
    .then((response) => {
      // debugger;
      if (props.raw) {
        return response
      } else {
        return parseResponse(response)
      }
    })
    .then((response) => {
      callback(response, props)
    })
    .catch((err) => {
      if (errorCallback) {
        errorCallback(err)
      } else {
        callback(err)
        console.warn(
          `The request for route: ${props.url} did not provide an error callback. The success callback was used instead.`
        )
      }
    })
}

export const GET = (url, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: url,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const PUT = (url, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: url,
      method: 'PUT',
    },
    callback,
    errorCallback
  )
}

export const SEARCH = (payload, category, callback, errorCallback) => {
  let queryString = '?'
  const keys = Object.keys(payload).filter((key) => {
    return payload[key] !== undefined && payload[key] !== null
  })
  keys.forEach((key, index) => {
    switch (key) {
      case 'FirstUseDate':
      case 'ExpirationDate':
      case 'SummonsAndComplaintDate':
      case 'SecretaryOfStateAcceptedServiceDate':
        const dates1 = payload[key]
        if (index === keys.length - 1 && !dates1.start && !dates1.end)
          queryString = queryString.substring(0, queryString.length - 1)
        if (dates1.start)
          queryString += `start${key}=${dates1.start}${
            index < keys.length - 1 || dates1.end ? '&' : ''
          }`
        if (dates1.end)
          queryString += `end${key}=${dates1.end}${index < keys.length - 1 ? '&' : ''}`
        break
      case 'FilingDate':
      case 'RegistrationDate':
        const dates = payload[key]
        if (index === keys.length - 1 && !dates.start && !dates.end)
          queryString = queryString.substring(0, queryString.length - 1)
        if (dates.start)
          queryString += `startDate=${dates.start}${
            index < keys.length - 1 || dates.end ? '&' : ''
          }`
        if (dates.end) queryString += `endDate=${dates.end}${index < keys.length - 1 ? '&' : ''}`
        break
      case 'IndividualName':
        const name = payload[key]
        if (
          index === keys.length - 1 &&
          !(name.FIRST_NAME || name.MIDDLE_NAME || name.LAST_NAME || name.SUFFIX)
        )
          queryString = queryString.substring(0, queryString.length - 1)
        if (name.FIRST_NAME || name.MIDDLE_NAME || name.LAST_NAME || name.SUFFIX)
          queryString += `firstName=${name.FIRST_NAME}&middleName=${name.MIDDLE_NAME}&lastName=${
            name.LAST_NAME
          }&suffix=${name.SUFFIX}${index < keys.length - 1 ? '&' : ''}`
        break
      case 'SEARCH_VALUE':
      case 'MailNumber':
      case 'PlaintiffAttorneyName':
      case 'PlaintiffName':
      case 'DefendantServedName':
      case 'AdditionalDefendantName':
      case 'OrganizationName':
        queryString += `${key}=${encodeURIComponent(payload[key])}`
        if (index < keys.length - 1) queryString += '&'
        break
      default:
        queryString += `${key}=${payload[key]}`
        if (index < keys.length - 1) queryString += '&'
        break
    }
  })
  fetchAndCatch(
    {
      url: encodeURI(
        `/api/${category}${
          USE_ENTITY_SEARCH_ENDPOINT ? 'EntitySearch/webSearch' : 'search'
        }${queryString}`
      ),
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SEARCH_DESCRIPTION = (category, callback) => {
  fetchAndCatch(
    {
      url: `/api/search/description/${category}`,
      method: 'GET',
    },
    callback
  )
}

export const GET_MY_RECORDS = (category, parameters, requestId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Records/GetMyRecords/${category}`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(parameters),
      requestId,
    },
    callback,
    errorCallback
  )
}

export const GET_MY_RECORD_SEARCH_FILTERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Records/GetMyRecordsSearchFilters`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MY_WORK_QUEUE_SEARCH_FILTERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/GetMyWorkQueueSearchFilters`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MY_RECORD_FILTER_OPTIONS = (url, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${url}/GetActiveBasicLookupTypes`,
      method: 'GET',
    },
    (data, props) =>
      callback(
        data.map((x) => {
          return { value: x.Id, label: x.Name }
        }),
        props
      ),
    errorCallback
  )
}

export const GET_FILING_DETAILS = (
  category,
  recordId,
  getSignal,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/FilingDetail/${category}/${recordId}`,
      method: 'GET',
      getSignal,
    },
    callback,
    errorCallback
  )
}

export const GET_ASSUMED_NAME_HISTORY = (recordId, getSignal, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FilingDetail/business/assumedNameHistory/${recordId}`,
      method: 'GET',
      getSignal,
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_WIZARDS = (category, callback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/${category ? `category/${category}` : ''}`,
      method: 'GET',
    },
    callback
  )
}

export const GET_LOOKUP_GROUPS = (type, callback) => {
  fetchAndCatch(
    {
      url: `/api/LookupGroup/${type}`,
      method: 'GET',
    },
    callback
  )
}

export const GET_LOOKUP_SUB_GROUPS = (id, callback) => {
  fetchAndCatch(
    {
      url: `/api/LookupSubGroup/${id}`,
      method: 'GET',
    },
    callback
  )
}

export const GET_GROUP_ITEMS = (groupId, includeAllOption = false, callback) => {
  const query = store.getState().router.location.search || ''
  fetchAndCatch(
    {
      url: `/api/GroupItems/${groupId}/${includeAllOption}${query}`,
      method: 'GET',
    },
    callback
  )
}

export const VALIDATE = (type, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Validation/${type}`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const CHECK_FOR_REGULATED_WORDS = (
  wordType,
  sourceType,
  recordType,
  recordSubType,
  input,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Validation/RegulatedWords/${wordType}/${sourceType}/${recordType}/${recordSubType}/${encodeURIComponent(
        input
      )}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const VALIDATE_INDIVIDUAL_NAME = (type, payload, callback, errorCallback) => {
  let queryString = '?'
  const keys = Object.keys(payload).filter((key) => {
    return !!payload[key]
  })
  keys.forEach((key, index) => {
    queryString += `${key}=${encodeURIComponent(payload[key])}`
    if (index < keys.length - 1) queryString += '&'
  })
  if (keys.length > 0) {
    fetchAndCatch(
      {
        url: `/api/IndividualNameValidation/${type}${queryString}`,
        method: 'GET',
      },
      callback,
      errorCallback
    )
  } else {
    callback({ IsValid: false, NoQueryMade: true })
  }
}

export const LOAD_WIZARD_BY_ID = (formDefinitionId, callback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizard/${formDefinitionId}`,
      method: 'GET',
    },
    callback
  )
}

export const GET_WIZARD_EXISTS = (formDefinitionId, callback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizardExists/${formDefinitionId}`,
      method: 'GET',
    },
    callback
  )
}

export const LOAD_WIZARD_HISTORY_BY_ID = (formDefinitionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizardHistory/${formDefinitionId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const LOAD_WIZARD_REVISION_STEPS_BY_ID = (
  formDefinitionId,
  revisionId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizardRevisionSteps/${formDefinitionId}/${revisionId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const LOAD_SECONDARY_VALIDATION_WIZARD = (
  formDefinitionId,
  filingNum,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/LoadSecondaryValidationWizard/${formDefinitionId}/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const LOAD_WIZARD_INJECT_METADATA = (
  formDefinitionId,
  amendmentNum = 'null',
  loadFromRecord = false,
  callback,
  errorCallback,
  query = '',
  isMiscellaneous = false
) => {
  const urlQuery = store.getState().router.location.search || ''
  const url = isMiscellaneous ? 
    `/api/FormDefinition/Miscellaneous/InjectMetaData/${formDefinitionId}/${
        amendmentNum === '' ? 'null' : amendmentNum
      }/${loadFromRecord}` :
    `/api/FormDefinition/GetWizardInjectMetadata/${formDefinitionId}/${
        amendmentNum === '' ? 'null' : amendmentNum
      }/${loadFromRecord}${query === '' ? urlQuery : query}`
  fetchAndCatch(
    {
      url: url,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_WIZARD = (wizard, callback, errorCallback) => {
  const wizardStr = window.btoa(utf8.encode(JSON.stringify(wizard)))
  const blob = new Blob([wizardStr], { type: 'text/plain' })
  const formData = new FormData()
  formData.append('file', blob, 'wizard.txt')
  fetchAndCatch(
    {
      url: `/api/FormDefinition/`,
      method: 'POST',
      body: formData,
      auth: true,
      contentType: 'text/plain',
    },
    callback,
    errorCallback
  )
}

export const SAVE_MISC_WIZARD = (wizard, callback, errorCallback) => {
  const wizardStr = window.btoa(utf8.encode(JSON.stringify(wizard)))
  const blob = new Blob([wizardStr], { type: 'text/plain' })
  const formData = new FormData()
  formData.append('file', blob, 'wizard.txt')
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous`,
      method: wizard.FORM_DEFINITION_ID > 0 ? 'PATCH' : 'POST',
      body: formData,
      auth: true,
      contentType: 'text/plain',
    },
    callback,
    errorCallback
  )
}

export const CLONE_WIZARD = (formDefinitionId, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/clone/${formDefinitionId}`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const ARCHIVE_WIZARD = (formDefinitionId, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/archive/${formDefinitionId}`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

const getFormDataObject = (files, payload = {}) => {
  let fileObject = new FormData()
  Object.keys(files).forEach((key) => {
    fileObject.append('file', files[key])
  })
  Object.keys(payload).forEach((key) => {
    fileObject.append(key, payload[key])
  })
  return fileObject
}

export const UPLOAD_FILES = (files, payload, onProgress) => {
  let opts = {}
  opts.body = getFormDataObject(files, payload)
  let AUTH = localStorage.getItem('USER_AUTHENTICATION')
  let auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {}

  let specialUserId = Cookies.get('special-user-id')

  if (!auth.ID) {
    console.debug('unable to find user from local storage. Checking cookies...')

    if (specialUserId && specialUserId !== '') {
      console.debug('user found in cookies. attaching credentials')
      auth.ID = specialUserId
    }
  } else if (specialUserId && specialUserId !== '' && auth.ID !== specialUserId) {
    console.debug(`overwritting auth.ID with MI Login value ${specialUserId}`)
    auth.ID = specialUserId
  }

  return new Promise((res, rej) => {
    var xhr = new XMLHttpRequest()
    xhr.open('POST', BASE_URL + '/api/FileUpload')
    xhr.setRequestHeader('Authorization', auth.ID)
    xhr.onload = (e) => res(e.target.responseText)
    xhr.onerror = rej
    if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress
    //xhr.addEventListener("progress", onProgress)
    xhr.send(opts.body)
  })
}

export const SEARCH_REGISTERED_AGENTS = (payload, callback) => {
  fetchAndCatch(
    {
      url: '/api/RA',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback
  )
}

export const GET_REGISTERED_AGENT_BY_ID = (id, callback) => {
  fetchAndCatch(
    {
      url: `/api/RA/${id}`,
      method: 'GET',
    },
    callback
  )
}
export const GET_BY_ID = (searchType, idAndQuery, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Search/${searchType}/${idAndQuery}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WORK_QUEUE_ITEMS = (category, parameters, requestId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/${category}`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(parameters),
      requestId,
    },
    callback,
    errorCallback
  )
}

export const BO_SEARCH = (payload, searchName, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${searchName}/search`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const PAPER_MODAL_ENTITY_SEARCH = (searchName, recordNum, queryTypeId, sourceTypeId, callback, errorCallback) => {
  let queryParams = ''
  if ((searchName || '') !== ''){
    queryParams += `searchName=${searchName}&`
  }
  if ((recordNum || '') !== ''){
    queryParams += `recordNum=${recordNum}&`
  }
  if ((queryTypeId || 0) !== 0){
    queryParams += `queryTypeId=${queryTypeId}`
  }
  if (queryParams !== ''){
    queryParams = `?${queryParams}`
    if (queryParams.endsWith('&')){
      queryParams = queryParams.substring(0, queryParams.length - 2)
    }
  }
  fetchAndCatch(
    {
      url: encodeURI(`/api/PaperProcessModal/Entity/${sourceTypeId}${queryParams}`),
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const BO_SEARCH_GET_CSV_RESULTS = (payload, searchName, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${searchName}/SearchCSVResults`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const BO_SEARCH_COUNT = (payload, searchName, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${searchName}/searchCount`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_STAFF_SEARCH_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/StaffSearchSettings/GetStaffSearchSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_ITEMS = (
  category,
  page,
  pageSize,
  myAssignedChecked,
  unassignedChecked,
  searchText,
  orderBy,
  orderByDesc,
  options,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: encodeURI(
        `/api/WorkviewItem/GetWorkItems/${category}/${page}/${pageSize}?myAssignedChecked=${!!myAssignedChecked}&unassignedChecked=${!!unassignedChecked}${
          searchText ? `&searchText=${searchText}` : ''
        }${orderBy ? `&orderBy=${orderBy}` : ''}${orderByDesc ? `&orderByDesc=${orderByDesc}` : ''}`
      ),
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_ITEMS_COUNT = (
  category,
  page,
  pageSize,
  myAssignedChecked,
  unassignedChecked,
  searchText,
  options,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: encodeURI(
        `/api/WorkviewItem/GetWorkItemCount/${category}/${page}/${pageSize}?myAssignedChecked=${!!myAssignedChecked}&unassignedChecked=${!!unassignedChecked}${
          searchText ? `&searchText=${searchText}` : ''
        }`
      ),
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_ITEM = (ID, lockItem = false, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewItem/GetWorkItem/${ID}${lockItem ? '?lockItem=true' : ''}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_ITEMS_SEARCH = (category, callback, errorCallback, { ...args } = {}) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetWorkItemsSearch/${category}`,
      method: 'POST',
      body: JSON.stringify(args),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_ITEM_HISTORY = (id, callback, errorCallback) => {
  // fetchAndCatch(
  //   {
  //   url: `/api/Workview/GetWorkItemHistory/${id}`,
  //   method: 'GET',
  //   auth: true,
  //   },
  //   callback,
  //   errorCallback
  // )
  if (id === 'a') {
    callback([
      {
        id: 1,
        user: null,
        action: 'Paper document received.',
        date: '4/14/20',
      },
      {
        id: 2,
        user: {
          FIRST_NAME: 'Mishka',
          LAST_NAME: 'Bahri',
          photoUrl: null,
        },
        action: 'scanned document',
        date: '4/15/20',
      },
      {
        id: 3,
        user: {
          FIRST_NAME: 'Harold',
          LAST_NAME: 'Wilkerson',
          photoUrl: null,
        },
        assignedTo: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
        },
        action: 'assigned document to',
        date: '4/15/20',
      },
      {
        id: 4,
        user: {
          FIRST_NAME: 'Harold',
          LAST_NAME: 'Wilkerson',
          photoUrl: null,
        },
        assignedTo: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
        },
        action: 'comment',
        comment:
          'This filing was missing one of the pages, but it came in a separate envelope, does it need a correction?',
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 6,
        user: {
          FIRST_NAME: 'Harold',
          LAST_NAME: 'Wilkerson',
          photoUrl: null,
        },
        action: 'comment',
        comment:
          "As long as it was identified as part of the same filing then a correction isn't needed.",
        date: '4/17/20',
      },
    ])
  } else {
    callback([
      {
        id: 1,
        user: null,
        action: 'Paper document received.',
        date: '4/14/20',
      },
      {
        id: 2,
        user: {
          FIRST_NAME: 'Mishka',
          LAST_NAME: 'Bahri',
          photoUrl: null,
        },
        action: 'scanned document',
        date: '4/15/20',
      },
      {
        id: 3,
        user: {
          FIRST_NAME: 'Harold',
          LAST_NAME: 'Wilkerson',
          photoUrl: null,
        },
        assignedTo: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
        },
        action: 'assigned document to',
        date: '4/15/20',
      },
      {
        id: 4,
        user: {
          FIRST_NAME: 'Harold',
          LAST_NAME: 'Wilkerson',
          photoUrl: null,
        },
        assignedTo: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
        },
        action: 'comment',
        comment:
          'This filing was missing one of the pages, but it came in a separate envelope, does it need a correction?',
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 5,
        user: {
          FIRST_NAME: 'Sadie',
          LAST_NAME: 'Baskins',
          photoUrl: null,
        },
        action: "tagged this record with 'Supervisor Review'",
        date: '4/16/20',
      },
      {
        id: 6,
        user: {
          FIRST_NAME: 'Harold',
          LAST_NAME: 'Wilkerson',
          photoUrl: null,
        },
        action: 'comment',
        comment:
          "As long as it was identified as part of the same filing then a correction isn't needed.",
        date: '4/17/20',
      },
    ])
  }
}

export const UPDATE_WORKVIEW_STATUS = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/UpdateItemStatus/`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEND_TO_SUPERVISOR = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/AssignToSupervisor/${id}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}
export const APPROVE_FILING_BY_WORKVIEW_ITEM_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/ApproveFilingByNum/${id}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const UNLOCK_WORKVIEW_ITEM_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewItem/UnlockItem/${id}`,
      method: 'PUT',
    },
    callback,
    errorCallback
  )
}

export const SAVE_RECORD = (json, category, mode, isCorrection, callback, errorCallback) => {
  if (USE_ENTITY_FRAMEWORK) {
    mode = mode === 'amendment' ? 'filing' : 'record'
  }
  fetchAndCatch(
    {
      url: `/api/${category}/${mode}${isCorrection ? '/correct' : ''}`,
      method: 'POST',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const VALIDATE_SECONDARY_REVIEW = (json, filingNum, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SecondaryValidation/${category}/${filingNum}`,
      method: 'PATCH',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const VALIDATE_SECONDARY_REVIEW_FIELD = (json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SecondaryValidateFieldsOnAdvance`,
      method: 'PATCH',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const IS_USING_LIEN_PARTY_EXTENSIONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PartyExtensionsInstallCheck`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_RECORD_WITH_SIGNATURES = (
  json,
  category,
  isCorrection,
  callback,
  errorCallback
) => {
  const { extraPayload: extraPayload = {}, ...payload } = json
  fetchAndCatch(
    {
      url: `/api/Signature/${category}${isCorrection ? '/correct' : ''}`,
      method: 'POST',
      body: JSON.stringify({ json: JSON.stringify(payload), ...extraPayload }),
    },
    callback,
    errorCallback
  )
}

export const GET_SIGNATURES_BY_GROUP_TOKEN = (groupToken, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Signature/${groupToken}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_SIGNER_EMAIL_BY_TOKEN = ({ SIGNER_EMAIL, TOKEN }, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Signature/update-email/${TOKEN}`,
      method: 'POST',
      body: JSON.stringify({ SIGNER_EMAIL }),
    },
    callback,
    errorCallback
  )
}

export const GET_SIGNATURE_FORM_BY_TOKEN = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Signature/form/${token}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const RESEND_SIGNER_EMAIL = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/signature/resend-email/${token}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY = (
  { token, category, payload },
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Signature/${token}/${category}`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_FILING_TYPE_IDS = (callback) => {
  fetchAndCatch(
    {
      url: `/api/FilingType`,
      method: 'GET',
    },
    callback
  )
}

export const SAVE_DRAFT = (payload, callback) => {
  const url = payload.CATEGORY === 'miscellaneous' ? '/api/Miscellaneous/Draft' : '/api/Draft'
  fetchAndCatch(
    {
      url,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback
  )
}

export const DELETE_DRAFT_BY_ID = (draftId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/DeleteDraft/${draftId}`,
      method: 'POST',
      auth: true,
    },
    callback
  )
}

export const LOAD_DRAFT_BY_ID = (draftId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Draft/${draftId}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const LOAD_FILING_BY_ID = (num, category, resubmission, callback, errorCallback) => {
  let url = `/api/${category}/`
  if (resubmission) {
    // If this is a resubmission for a correction then num will be the FilingNum
    url += `correct-filing/${num}`
  } else {
    // If this is a brand new amendment filing and num will be the RecordNum
    url += `filing/${num}`
  }

  fetchAndCatch(
    {
      url: url,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const LOAD_READONLY_FILING_BY_ID = (filingNum, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${category}/view-filing/${filingNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const DELETE_RECORD_BY_ID = (draftId, category, callback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/DeleteRecord/${category}/${draftId}`,
      method: 'POST',
      auth: true,
    },
    callback
  )
}

export const DELETE_MISC_FILING_BY_ID = (filingId, callback) => {
  fetchAndCatch(
    {
      url: `/api/Miscellaneous/WorkQueue/${filingId}`,
      method: 'DELETE',
      auth: true,
    },
    callback
  )
}

export const GET_HOME_PAGE_STRUCTURE = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/home`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_APP_SETTING_BY_NAME = (name, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/${name}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RESOLVED_APP_SETTING_BY_NAME = (name, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/${name}/true`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_APP_SETTINGS_BY_NAME = (settingNames, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/getSettingsByName`,
      method: 'POST',
      body: JSON.stringify(settingNames),
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_APP_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/getAvailableAppSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CONFIGURABLE_APP_SETTINGS = (category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/getConfigurableAppSettings/${category}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CONFIGURABLE_APP_SETTING_CATEGORIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/getConfigurableAppSettingCategories`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_APP_SETTING_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/GetEditableSettingById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_APPLICATION_SETTING = (isAdding, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/${isAdding ? 'SaveNew' : 'Update'}`,
      method: 'POST',
      body: window.btoa(JSON.stringify(payload)),
      contentType: 'text/plain',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_APP_SETTING_BY_ID = (id, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/${id}`,
      method: 'POST',
      body: window.btoa(JSON.stringify(payload)),
      contentType: 'text/plain',
    },
    callback,
    errorCallback
  )
}

export const GET_BUSINESS_WIZARD_STAFF_ENTRY_REQUIRED = (
  recordTypeId,
  filingTypeId,
  recordSubTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordDetails/GetStaffEntryRequiredByWorkviewItemId/${recordTypeId}/${filingTypeId}${
        recordSubTypeId ? `/${recordSubTypeId}` : ''
      }`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CREATE_WEB_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/createWebUser',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEND_EMAIL_REGISTRATION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/UserAccount/createWebUserWithEmailRegistration',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEND_EMAIL_VERIFICATION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/UserAccount/sendEmailVerification',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEND_PASSWORD_RESET_EMAIL = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/UserAccount/sendPasswordReset',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEND_FORGOT_USERNAME_EMAIL = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/UserAccount/sendForgotUsername',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const CHANGE_PASSWORD = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/changePassword',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const PARSE_PASSWORD_RESET_TOKEN = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/parseResetToken',
      method: 'POST',
      body: JSON.stringify({ token }),
    },
    callback,
    errorCallback
  )
}

export const LOGIN_WEB_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/login',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const LOGIN_APP_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/app_login',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const LOGOUT_WEB_USER = (callback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/logout',
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const GET_AUTH_STATE = (callback) => {
  fetchAndCatch(
    {
      url: '/api/Auth',
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const EXTEND_WEB_USER_SESSION = (staleToken, callback) => {
  fetchAndCatch(
    {
      url: `/api/Auth/extend?staletoken=${staleToken}`,
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM = (
  amendmentNum,
  category,
  correctionMode,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/${category}/getWebCart/${amendmentNum}/${correctionMode}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_CART_BY_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getWebCart/${refNum}`,
      method: 'GET',
      auth: false,
    },
    callback,
    errorCallback
  )
}

export const REMOVE_FROM_WEB_CART_BY_GUID = (guid, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/removeFromCart/${guid}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_USER_ACTIVE_CART = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getWebUserActiveCart`,
      method: 'GET',
      auth: false,
    },
    callback,
    errorCallback
  )
}

export const POST_PAYMENT = (payload, category, callback) => {
  fetchAndCatch(
    {
      url: `/api/${category}/getWebCart`,
      method: 'POST',
      body: JSON.stringify({ type: 'CREDIT', ...payload }),
      auth: true,
    },
    callback
  )
}

export const BYPASS_PAYMENT = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/activate`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const SEARCH_BY_KEY = (searchTypeKey, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Search/${searchTypeKey}`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_RECORDS_BY_USER = (searchType, payload, callback) => {
  let params = payload ? `?${new URLSearchParams(payload)}` : ''
  fetchAndCatch(
    {
      url: `/api/RecordsByUser/${searchType}${params}`,
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const GET_WEB_USER_ACCESS_LIST = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/${getSourceTypeId(category)}/${sourceId}`,
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const GET_RECORD_PINS = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/${getSourceTypeId(category)}/${sourceId}`,
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const REQUEST_NEW_PIN = (category = 'business', sourceId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Pin`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId }),
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_USER_ACCESS_WITH_PIN = (payload, callback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/validatePin`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(payload),
    },
    callback
  )
}

export const GET_WEB_USER_ACCESS_WITH_GENERIC_PIN = (pin, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/validateGenericPin/${pin}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const MI_CHECK_RECORD_ACCESS = (sourceId, sourceTypeId, callback) => {
  fetchAndCatch(
    {
      url: `/api/MichiganRecordAccess/${sourceTypeId}/${sourceId}`,
      method: 'GET',
      auth: true,
    },
    callback
  )
}

export const MI_REQUEST_RECORD_ACCESS = (
  sourceId,
  sourceTypeId,
  recordNum,
  registrationDate,
  turnstileToken,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/MichiganRecordAccess/RequestAccess`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({
        SourceTypeId: sourceTypeId,
        RecordId: sourceId,
        RecordNum: recordNum,
        RegistrationDate: registrationDate,
        TurnstileToken: turnstileToken,
      }),
    },
    callback,
    errorCallback
  )
}

export const GET_REQUEST_ACCESS_CONFIG = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MichiganRecordAccess/RequestAccessConfig`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const MI_RELINQUISH_RECORD_ACCESS = (sourceId, sourceTypeId, callback) => {
  fetchAndCatch(
    {
      url: `/api/MichiganRecordAccess/RelinquishAccess`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SourceTypeId: sourceTypeId, RecordId: sourceId }),
    },
    callback
  )
}

export const GET_WEB_USER_IS_RECORD_OWNER = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/GetUserIsOwner`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId }),
    },
    callback
  )
}

export const GET_RECORD_HAS_OWNERS = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/GET_RECORD_HAS_OWNERS`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId }),
    },
    callback
  )
}

export const GET_RECORD_HAS_ACTIVE_PIN = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/GET_RECORD_HAS_ACTIVE_PIN`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId }),
    },
    callback
  )
}

export const REQUEST_RECORD_ACCESS = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/REQUEST_RECORD_ACCESS`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId }),
    },
    callback
  )
}

export const GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS = (
  category = 'business',
  sourceId,
  callback
) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/GET_USER_HAS_ALREADY_REQUESTED`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId }),
    },
    callback
  )
}

// #region Manage User Access 2.0
export const GET_RECORD_USER_ACCESS_ENTRIES = (sourceTypeId, sourceId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/AllAccessEntriesToRecord/${sourceTypeId}/${sourceId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RECORD_ACCESS_USER_ROLES_BY_SOURCE_TYPE = (
  sourceTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole/GetUserAccessRoles/${sourceTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_RECORD_ACCESS_ROLES_BY_MODULE = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole/GetMiscellaneousModuleRoles/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const ACCEPT_RECORD_ACCESS_REQUEST = (
  RecordAccessRequestId,
  RecordAccessUserRoleId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/ApproveRequest`,
      method: 'POST',
      body: JSON.stringify({ RecordAccessRequestId, RecordAccessUserRoleId }),
    },
    callback,
    errorCallback
  )
}

export const REJECT_RECORD_ACCESS_REQUEST = (RecordAccessRequestId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/RejectRequest`,
      method: 'POST',
      body: JSON.stringify({ RecordAccessRequestId }),
    },
    callback,
    errorCallback
  )
}

export const REVOKE_RECORD_ACCESS = (RecordAccessId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/RevokeAccess`,
      method: 'POST',
      body: JSON.stringify({ RecordAccessId }),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_RECORD_USER_ACCESS = (
  RecordAccessId,
  RecordAccessUserRoleId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/UpdateAccess`,
      method: 'POST',
      body: JSON.stringify({ RecordAccessId, RecordAccessUserRoleId }),
    },
    callback,
    errorCallback
  )
}

// #endregion

export const GET_AVAILABLE_AMENDMENTS = (filingNum, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetAvailable${category}Amendments/${filingNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_ORDER_FILINGS = (recordId, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/orders/GetAvailableOrderFilings/${category}/${recordId}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_ORDER_FILINGS_STAFF = (recordId, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/orders/GetAvailableStaffOrderFilings/${category}/${recordId}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_ORDER_FILING_DETAILS = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderFilingDetail/${filingNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_AR_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetARFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SPECIAL_AMENDMENT_FORM_DEFINITION_ID = (
  filingNum,
  category,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/${category}/GetSpecialAmendmentFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_REINSTATEMENT_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetReinstatementFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetContractorRenewalFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CHARITABLE_AR_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetCharitableARFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetCharitableRenewalFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetLobbyistRenewalFormDefinitionId/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_EXPENDITURES = (sourceId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Lobbyist/Expenditures/${sourceId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_REPORT_PREVIEW = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report`,
      method: 'POST',
      auth: true,
      raw: true,
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_REPORT_BY_JSON = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report`,
      method: 'POST',
      auth: true,
      raw: true,
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_REPORTS = (formDefinitionId, record_num, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report/${formDefinitionId}/${record_num}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_REPORT_BY_REPORT_OBJECT = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report/getbyreportobject`,
      method: 'POST',
      raw: true,
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_PAYPAL_TOKEN = (refNum, riskCheckInfo, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getPaypalToken/${refNum}`,
      method: 'GET',
      body: riskCheckInfo !== null ? JSON.stringify(riskCheckInfo) : null,
    },
    callback,
    errorCallback
  )
}
export const GET_PAYEEZY_HASH = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getPayeezyHash`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}
export const GET_ACCESSIDCC_TOKEN = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getAccessIDCCToken/${refNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ACCESSIDLOC_TOKEN = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getAccessIDLOCToken/${refNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SERVER_DATES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Date`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_TABLES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataTable`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_TABLE_BY_ID = (id, metadata = {}, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataTable/GetById/${id}`,
      method: 'POST',
      body: JSON.stringify(metadata),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_MERGE_CODES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MergeCode/GetList`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_MERGE_CODES_BY_ARRAY = (mergeCodes, metaData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MergeCode/getValues`,
      method: 'POST',
      body: JSON.stringify({
        mergeCodes,
        metaData,
      }),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_RECORD_HISTORY = (category, amendmentNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/History/${category}/${amendmentNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_STAFF_RECORD_HISTORY = (category, amendmentNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/History/${category}/${amendmentNum}?staffSearch=true`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYISTS_BY_SEARCH_AND_RANGE = (year, searchValue, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/list/search`,
      method: 'POST',
      body: JSON.stringify({
        YEAR: year,
        SEARCH_VALUE: searchValue,
      }),
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_ENTITIES_BY_ID = (lobbyistId, year, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/list/getEntitiesByID/${lobbyistId}/${year}`,
      method: 'get',
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_LISTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/list/getAvailableLists`,
      method: 'get',
    },
    callback,
    errorCallback
  )
}

export const GET_HCDR_RECORD = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/records/hcdrsearch`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_APOSTILLE_RECORD = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ApostilleEntitySearch/webSearch`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_CCP_PAYMENT_STATUS = (webCartNum, token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getCCPPaymentStatus/${webCartNum}/${token}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WALLETAPI_NON_SAVED_PAYMENT_STATUS = (webCartNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/GetWalletAPINonSavedPaymentStatus/${webCartNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_PAYEEZY_PAYMENT_STATUS = (
  x_invoice_num,
  x_response_code,
  x_trans_id,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/payment/getPayeezyPaymentStatus/${x_invoice_num}/${x_response_code}/${x_trans_id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const GET_ACCESS_ID_CC_PAYMENT_STATUS = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getAccessIDCCPaymentStatus/${token}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ACCESS_ID_LOC_PAYMENT_STATUS = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getAccessIDLOCPaymentStatus/${token}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_PAYPAL_PAYMENT_STATUS = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getPaypalPaymentStatus/${token}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CERTIFICATION_CONFIG = (category, filingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification/getCertificationConfig/${category}/${filingId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CREATE_CERTIFICATION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_CART_BY_CERTIFICATION_ID = (certificationId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification/getWebCart/${certificationId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_REPORTS_BY_WEB_CART_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report/GetReportsByCartRefNum/${refNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_PAYMENT_METHODS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getPaymentMethodStatus`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const VERIFY_CERTIFICATE = (ref_num, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/certification/verifyCertificate/${ref_num}${
        category ? `?category=${category}` : ''
      }`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SEARCH_UCC_INFO_REQ = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestSearch`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEARCH_UCC_INFO_REQ_COUNT = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestSearch/GetCount`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SEARCH_UCC_INFO_REQ_GET_TEMPLATE = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestSearch/GetTemplate`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_DATA = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DashboardTile/getData`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_LIENS_SEARCH_WEB_CART = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/copies/premium`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_WEB_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/auth/updateWebUser`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_PAYROC_CUSTOMER = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocCustomerGet`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CREATE_PAYROC_TRANSACTION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocTransactionCreate`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocAddPaymentSource`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocDeletePaymentSource`,
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_REQUEST_WIZARDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataRequests/GetDataRequestDefinitions`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MY_DATA_REQUESTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataRequests/GetList`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_DATA_REQUEST_NAME = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/dataRequests/UpdateFilingNickname',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_DATA_REQUEST_CANCEL_SUB = (DataRequestFilingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/dataRequests/CancelFiling/${DataRequestFilingId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_DATA_REQUEST_PAUSE_SUB = (DataRequestFilingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/dataRequests/PauseFiling/${DataRequestFilingId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_DATA_REQUEST_RESUME_SUB = (DataRequestFilingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/dataRequests/PauseFiling/${DataRequestFilingId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_DATA_REQUEST = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/dataRequests/UpdateFiling',
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}
export const DELETE_DATA_REQUEST_FILING = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/dataRequests/DeleteFiling/${id}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_EPASS_LOGIN_CALLBACK = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Epass/ProcessLogin',
      method: 'GET',
      cookies: true,
    },
    callback,
    errorCallback
  )
}

export const GET_HAS_FARM_BILL_SUBSCRIPTION = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/DataRequests/GetActiveSubscription/-lists-farm-bill',
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_XML_USERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/customerprofile/getlist',
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_XML_PAYROC_CUSTOMER = (profileId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocCustomerGet/${profileId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const ADD_XML_PAYROC_PAYMENT_METHOD = ({ profileId, token }, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocAddPaymentSource`,
      method: 'POST',
      body: JSON.stringify({ profileId, token }),
    },
    callback,
    errorCallback
  )
}

export const SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD = (
  { profileId, paySourceNum },
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocSetDefaultPaymentSource`,
      method: 'POST',
      body: JSON.stringify({ profileId, paySourceNum }),
    },
    callback,
    errorCallback
  )
}

export const SET_XML_PAYROC_DELETE_PAYMENT_METHOD = (
  { profileId, paySourceNum },
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocDeletePaymentSource`,
      method: 'POST',
      body: JSON.stringify({ profileId, paySourceNum }),
    },
    callback,
    errorCallback
  )
}

export const SET_WEB_USER_ACCESS_LEVEL = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/SET_ACCESS_LEVEL`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FrequentPayor`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_FREQUENT_PAYOR_ADDRESS = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FrequentPayor/updateAddress`,
      method: 'PUT',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/payWithFrequentPayor/${refNum}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR = (
  payload,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Payment/payWithFrequentPayor`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT = (amount, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FrequentPayor/getWebCart/${Math.round(amount * 100)}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_STATEMENT = (date, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/report/frequentPayorStatement?date=${date}`,
      method: 'GET',
      raw: true,
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/GetFrequentPayorByNum/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_LINKED_ACCOUNTS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/GetLinkedAccounts/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_GET_COMMENTS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/GetComments/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_TRANSACTIONS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/GetAccountTransactions/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const ADD_FREQUENT_PAYOR = (payor, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/Save`,
      method: 'POST',
      body: JSON.stringify(payor),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_FREQUENT_PAYOR = (payor, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/Save`,
      method: 'POST',
      body: JSON.stringify(payor),
    },
    callback,
    errorCallback
  )
}

export const GET_ELAVON_TOKEN_BY_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getElavonToken/${refNum}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const GET_ELAVON_TOKEN_BY_ITEM_GUIDS = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getElavonToken`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const PROCESS_ELAVON_PAYMENT = (body, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/elavonactivate`,
      method: 'POST',
      body: JSON.stringify(body),
    },
    callback,
    errorCallback
  )
}

export const GET_VERSION_INFO = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/VersionInfo`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_REGULATED_WORD_LISTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWordType/GetActiveBasicLookupTypes`,
    },
    callback,
    errorCallback
  )
}
export const GET_WEB_SEARCH_COLUMNS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SearchControlValidation`,
    },
    callback,
    errorCallback
  )
}

export const GET_USERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/GetUsers`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_ASSIGNED_WORKVIEW_USER_BY_ID = (body, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItem/AssignItem`,
      method: 'POST',
      body: JSON.stringify(body),
    },
    callback,
    errorCallback
  )
}

export const BULK_ASSIGN_WORKVIEW_ITEMS = (list, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItem/AssignItem`,
      method: 'POST',
      body: JSON.stringify(list),
    },
    callback,
    errorCallback
  )
}

export const REASSIGN_ITEM_TO_INITIAL_REVIEWER = (itemId, userId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItem/AssignToInitialReviewer/${itemId}/${userId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

/**
 * Updated version of reassigning a WorkViewItem to its initial reviewer.
 * @param {*} itemId The ID of the WorkViewItem
 * @param {*} userId The ID of the User to reassign the WorkViewItem to.
 * @param {*} callback The callback function on success.
 * @param {*} errorCallback The callback function on failure.
 */
export const REASSIGN_ITEM_TO_INITIAL_REVIEWER_UPDATED = (
  itemId,
  userId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItem/Filing/AssignToInitialReviewer/${itemId}/${userId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const SET_USER_GROUPS_BY_USER_ID = ({ USER_ID, GROUPS }, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SetUserGroupRights/${USER_ID}`,
      method: 'POST',
      body: JSON.stringify({ GROUPS }),
    },
    callback,
    errorCallback
  )
}

export const GET_USER_INFO_BY_USER = (userId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/user-roles/web-user/${userId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_USER_AND_ROLES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/user-roles`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_USERS_LIST = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetWorkviewUsers`, // replace once finished.
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_USERS_LIST = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetProductivityUsers`, // replace once finished.
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_USER_GROUP_RIGHTS = ({ USER_ID, RIGHTS }, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SetUserGroupRights/${USER_ID}`,
      method: 'POST',
      body: JSON.stringify({ RIGHTS }),
    },
    callback,
    errorCallback
  )
}

export const SEARCH_USERS = (searchValue, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserSearch/search`,
      method: 'POST',
      body: JSON.stringify(searchValue),
    },
    callback,
    errorCallback
  )
}

export const SEARCH_WEB_USER_GROUPS = (searchValue, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserGroups/search`,
      method: 'POST',
      body: JSON.stringify({
        SEARCH_VALUE: searchValue,
      }),
    },
    callback,
    errorCallback
  )
}

export const GET_IMAGE_ENVELOPE_BY_ID = (envelopeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/${envelopeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ENVELOPE_ID_BY_DLN = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/GetEnvelopeID/${dln}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_IMAGE_BY_DLN = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/LoadByDLN/${dln}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RECEIPT_NUM_BY_IMAGE_ENVELOPE_ID = (imageEnvelopeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/GetReceiptNum/${imageEnvelopeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_IMAGE_ENVELOPE_REPORTS = (imageEnvelopeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/GetEnvelopeReports/${imageEnvelopeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_IMAGE_GROUP_DLNS = (imageGroupID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Image/GetImageGroupDLNs/${imageGroupID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_EXISTING_CORRESPONDENCE = (CorrespondenceNumber, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondence/GetCustomCorrespondence/${CorrespondenceNumber}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CORRESPONDING_REASONS = (props, callback, errorCallback) => {
  const {
    SourceTypeId,
    CustomCorrespondenceTypeId,
    RecordTypeId,
    RecordSubTypeId = null,
    FilingTypeId,
  } = props
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondence/RetrieveCorrespondenceReasons/${SourceTypeId}/${CustomCorrespondenceTypeId}/${
        RecordTypeId ? RecordTypeId : 0
      }/${FilingTypeId ? FilingTypeId : 0}/${
        RecordSubTypeId
          ? RecordSubTypeId === 'None' || RecordSubTypeId === 'null'
            ? ''
            : RecordSubTypeId
          : ''
      }`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISCELLANEOUS_CORRESPONDING_REASONS = (
  CustomCorrespondenceTypeId,
  MiscellaneousModuleId,
  FilingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondence/RetrieveMiscellaneousCorrespondenceReasons/${CustomCorrespondenceTypeId}/${MiscellaneousModuleId}/${FilingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CORRESPONDENCE_REASONS_BY_CUSTOM_CORRESPONDENCE_ID = (
  customCorrespondenceId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondence/RetrieveCorrespondenceReasons/${customCorrespondenceId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const POST_CORRESPONDENCE = (customCorrespondence, callback, errorCallback) => {
  try {
    var bodyMessage = window.btoa(utf8.encode(JSON.stringify(customCorrespondence)))
    fetchAndCatch(
      {
        url: `/api/CustomCorrespondence/SaveCorrespondence`,
        method: 'POST',
        body: bodyMessage,
        contentType: 'text/plain',
      },
      callback,
      errorCallback
    )
  } catch (e) {
    console.error(e)
  }
}

export const REJECT_CORRECT_FILING = (module, documentNumber, status, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${module}/SetCorrectionOrRejection/${documentNumber}/${status}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const CLEAR_FAILED_WEB_CART_BY_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/clearFailedCart/${refNum}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_DROPDOWN_OPTIONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetDataCategoryCount`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WORKVIEW_OPTIONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetWorkviews`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_WORKVIEW_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetWorkViewById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const SAVE_SETTINGS_WORK_VIEW = (method, dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/Save`,
      method,
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}
export const DELETE_SETTINGS_WORK_VIEWS = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/Delete`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}
export const GET_ALL_REPLACEMENT_WORDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReplacementWord/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const GET_REPLACEMENT_WORDS_BY_CATEGORY = (category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReplacementWord/GetAll/${category > 0 ? category : ''}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const GET_SETTINGS_REPLACEMENT_WORD_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReplacementWord/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const SAVE_SETTINGS_WORD_REPLACEMENT = (method, dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReplacementWord`,
      method,
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}
export const DELETE_SETTINGS_REPLACEMENT_WORDS = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReplacementWord`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_INITIAL_FILING_WIZARDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetUCCInitialFilings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_WIZARDS = (FilingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetUCCFilingTypes/${FilingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_BUSINESS_CERTIFICATION_WIZARDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetBusinessCertificationTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_AMENDMENT_WIZARDS = (sourceTypeId, recordId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AmendmentWizards/${sourceTypeId}?recordId=${recordId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_BUSINESS_AMENDMENT_WIZARDS = (FilingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetAmendmentWizards/${FilingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_WIZARDS = (FilingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetNotaryFilingTypes/${FilingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_TRADEMARK_WIZARDS = (FilingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetTrademarkFilingTypes/${FilingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_REGISTERED_AGENT_WIZARDS = (FilingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetRegisteredAgentFilingTypes/${FilingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ATHLETE_AGENT_AMENDMENT_WIZARDS = (recordNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetAthleteAgentAmendmentWizards/${recordNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FORMS = (category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkviewDefinitions/GetForms/${category}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_SEARCH_OPTIONS = (object, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/' + object.name + '/DropDownValues/' + object.apiCall,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_IMAGE_HTML = (imageNumber, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Image/GetImageHTML/' + imageNumber,
    },
    callback,
    errorCallback
  )
}

export const FETCH_BUSINESS_ENTITY_RECORD_DETAIL_SETTINGS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordDetails/GetFieldSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const SET_BUSINESS_ENTITY_RECORD_DETAIL_SETTINGS = (config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordDetails/SetFieldSettings`,
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const SAVE_HTML_REDACTION = (update, callback, errorCallback) => {
  fetchAndCatch(
    {
      contentType: 'text/plain',
      url: '/api/ImageEnvelope/UpdateHTMLRedaction/',
      method: 'POST',
      body: window.btoa(utf8.encode(JSON.stringify(update))),
    },
    callback,
    errorCallback
  )
}

export const SAVE_IMAGE_REDACTION = (dln, rects, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/UpdateDataRedaction/${dln}`,
      method: 'POST',
      body: JSON.stringify(rects),
    },
    callback,
    errorCallback
  )
}

export const SEND_IMAGE_TO_PRINT_QUEUE = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PrintQueue/SendImageToPrintQueue/${dln}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const FETCH_BUSINESS_ENTITY_RECORD_DETAILS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordDetails/GetRecordDetails/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_RECORD_DETAIL_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordDetails/GetFieldSettings`, //SetFieldSettings
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_NOTARY_RECORD_DETAIL_SETTINGS = (config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordDetails/SetFieldSettings`, //SetFieldSettings
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const GET_APOSTILE_RECORD_DETAIL_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ApostilleRecordDetails/GetFieldSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_APOSTILE_RECORD_DETAIL_SETTINGS = (config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ApostilleRecordDetails/SetFieldSettings`,
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_FILING_DETAIL_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingDetails/GetFieldSettings`, //SetFieldSettings
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_UCC_FILING_DETAIL_SETTINGS = (config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingDetails/SetFieldSettings`, //SetFieldSettings
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_FILING_INFO_REQUESET_DETAIL_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestRecordDetails/GetFieldSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_INFO_REQUEST_DETAIL_ZIP = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestRecordDetails/GetZipFile/` + filingNum,
      raw: true,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_UCC_FILING_INFO_REQUESET_DETAIL_SETTINGS = (config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestRecordDetails/SetFieldSettings`,
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_REQUEST_DETAIL_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataRequestRecordDetail/GetFieldSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_DATA_REQUEST_DETAIL_SETTINGS = (config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataRequestRecordDetail/SetFieldSettings`,
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const GET_RECORD_DETAIL_SETTING_BY_TYPE = (route, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${route}/GetFieldSettings`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_RECORD_DETAIL_SETTING_BY_TYPE = (route, config, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${route}/SetFieldSettings`,
      method: 'POST',
      body: JSON.stringify(config),
    },
    callback,
    errorCallback
  )
}

export const FETCH_BUSINESS_ENTITY_RECORD_DETAIL_HISTORY = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordDetails/GetHistory/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_BUSINESS_ENTITY_RECORD_DETAIL = (entityData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/business-entity-update/${entityData.FILING_NUM}`,
      method: 'POST',
      body: JSON.stringify({
        ...entityData,
        FILING_NUM: undefined,
      }),
    },
    callback,
    errorCallback
  )
}

export const VOID_BE_AMENDMENT = (entityData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/business-entity-void-amendment/${entityData.amendmentNum}`,
      method: 'POST',
      body: JSON.stringify({
        ...entityData,
        amendmentNum: undefined,
        FILING_NUM: undefined,
      }),
    },
    callback,
    errorCallback
  )
}

export const VOID_FILING = (entityNum, category, voidinfo, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${category}/voidRecord/${entityNum}`,
      method: 'POST',
      body: JSON.stringify(voidinfo),
    },
    callback,
    errorCallback
  )
}

export const FETCH_BUSINESS_RECORD_DETAIL_HISTORY = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordDetails/GetHistory/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const EDIT_BUSINESS_FILING = (filingInfo, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/business/editFiling/${filingInfo.FilingNumber}`,
      method: 'PUT',
      body: JSON.stringify({
        ...filingInfo,
      }),
    },
    callback,
    errorCallback
  )
}

export const FETCH_BUSINESS_AMENDMENT_RECORD_DETAIL_EVENTS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetAmendmentEvents/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_BUSINESS_AMENDMENT_RECORD_DETAIL_CORRESPONDENCE = (
  id,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetAmendmentEvents/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_TRADEMARK_RECORD_NOTES = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Note/GetNotes/810/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_TRADEMARK_RECORD_DETAILS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkRecordDetail/GetRecordDetails/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_TRADEMARK_FILING_HISTORY = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkRecordDetail/GetFilingHistory/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const EDIT_TRADEMARK_FILING = (filingInfo, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/trademark/editFiling/${filingInfo.FilingNumber}`,
      method: 'PUT',
      body: JSON.stringify({
        ...filingInfo,
      }),
    },
    callback,
    errorCallback
  )
}

export const FETCH_RECORD_DETAILS_BY_ROUTE = (route, id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${route}/GetRecordDetails/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_CERTIFICATION_RECORD_DETAILS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification/GetCertification/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_CERTIFICATION_RECORD_NOTES = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification/GetNotes/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_REGISTERED_AGENT_RECORD_DETAILS = (num, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentRecordDetail/GetRecordDetails/${num}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_STATUSES_BY_CATEGORY = (category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TypeV/GetCategory/${category}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_RECEIPT_DETAILS = (receiptId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/GetReceipt/${receiptId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_RECEIPT_DATA = (receiptData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/SaveReceipt`,
      method: 'POST',
      body: JSON.stringify({
        ...receiptData,
      }),
    },
    callback,
    errorCallback
  )
}

export const CREATE_FREQUENT_PAYOR_DEPOSIT_FILING = (receiptData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/CreateFrequentPayorDepositFiling`,
      method: 'POST',
      body: JSON.stringify({
        ...receiptData,
      }),
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_RECEIPT_PDF = (receiptNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/GetReceiptReport/${receiptNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_CUSTOM_CORRESPONDENCE_PDF = (
  correspondenceTypeID,
  correspondenceId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondence/GetReport/${correspondenceTypeID}/${correspondenceId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_BUSINESS_ENTITY_REPORTS = (amendmentNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/business/GetReports/${amendmentNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_TRADEMARK_REPORTS = (trademarkAmendmentNumber, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/trademark/GetTrademarkReport/${trademarkAmendmentNumber}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_UCC_REPORTS = (uccAmendmentNumber, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ucc/GetUCCReport/${uccAmendmentNumber}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_ORDER_REPORTS = (orderNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Orders/GetReport/${orderNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_NOTARY_REPORTS = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Notary/GetReport/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_APOSTILLE_REPORTS = (apostilleNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Apostille/GetReport/${apostilleNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_REGISTERED_AGENT_REPORTS = (registeredAgentNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgent/GetReport/${registeredAgentNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_FACSIMILE_REPORTS = (facsimileNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FacsimileSignature/GetReport/${facsimileNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_SERVICE_OF_PROCESS_REPORTS = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ServiceOfProcess/GetReport/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DOWNLOAD_REPORTS = (sourceTypeId, filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FilingReport/${sourceTypeId}/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const SAVE_TO_AZURE = (receiptData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/SaveToAzure`,
      method: 'POST',
      body: JSON.stringify({
        ...receiptData,
      }),
    },
    callback,
    errorCallback
  )
}

export const TIE_RECEIPT_TO_IMAGE_ENVELOPE = (
  receiptID,
  imageEnvelopeID,
  workViewItemId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/receipt/AssignToImageEnvelope`,
      method: 'POST',
      body: JSON.stringify({
        ReceiptId: receiptID,
        ImageEnvelopeId: imageEnvelopeID,
        WorkViewItemId: workViewItemId,
      }),
    },
    callback,
    errorCallback
  )
}
// #region WorkViewItemNotes
export const GET_WORK_VIEW_ITEM_NOTES_BY_WORK_VIEW_ITEM_ID = (
  workViewItemId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItemNote/GetByWorkViewItemId/${workViewItemId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_WORK_VIEW_ITEM_NOTE_BY_NOTE_ID = (
  workViewItemNoteId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItemNote/DeleteById/${workViewItemNoteId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const ADD_WORK_VIEW_ITEM_NOTE = (workViewItemNote, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItemNote/AddNote`,
      method: 'POST',
      body: JSON.stringify(workViewItemNote),
    },
    callback,
    errorCallback
  )
}

export const EDIT_WORK_VIEW_ITEM_NOTE = (workViewItemNote, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkViewItemNote/UpdateNote`,
      method: 'POST',
      body: JSON.stringify(workViewItemNote),
    },
    callback,
    errorCallback
  )
}

// #endregion

export const FETCH_RECEIPT_ITEM_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/GetReceiptTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_AMENDMENT_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ucc/GetAmendmentTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_AMENDMENT_ACTION_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ucc/GetAmendmentActionTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_PARTY_ACTION_IDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ucc/GetPartyActions`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_AMENDMENT_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ucc/getAmendmentByID/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_AMENDMENT_BY_NUM = (num, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingDetails/${num}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_AMENDMENT_HISTORY = (num, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingDetails/ucc-history/${num}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_FILING_CREATED_BY_USER_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingDetails/GetUccCreatedById/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FILING_LAST_MODIFIED_BY_USER_ID = (
  sourceTypeId,
  filingNum,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/filing/GetLastModifiedById/${sourceTypeId}/${filingNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_XML_USER_ACCESS_LIST = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCXmlUserAccess`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_XML_USER_ACCESS_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCXmlUserAccess/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_USER_XML_API_ACCESS = (UserId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCXmlUserAccess`,
      method: 'POST',
      body: JSON.stringify({ UserId: UserId }),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_USER_XML_API_ACCESS = (UserId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCXmlUserAccess/${UserId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_BUSINESS_XML_USER_ACCESS_LIST = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessXmlUserAccess`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_BUSINESS_XML_USER_ACCESS_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessXmlUserAccess/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_XML_USER_ACCESS = (body, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessXmlUserAccess`,
      method: 'POST',
      body: JSON.stringify(body),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_SETTINGS_BUSINESS_XML_USER_ACCESS = (userId, registeredAgentRecordId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessXmlUserAccess/${userId}`,
      method: 'PUT',
      body: JSON.stringify({ RegisteredAgentRecordId: registeredAgentRecordId }),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_BUSINESS_XML_USER_ACCESS = (UserId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessXmlUserAccess/${UserId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const FETCH_RECEIPT_ITEM_TYPE_ENUMS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/GetReceiptItemTypeIDs`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const FETCH_WEB_USER_FROM_SOURCE_ID = (sourceID, sourceTypeID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserRecord/GetWebUserFromSourceID/${sourceID}/${sourceTypeID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_WEB_USER_EMAIL_FROM_FILING_NUM = (
  filingNum,
  sourceTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/WebUserRecord/GetWebUserEmailFromSourceNum/${filingNum}/${sourceTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_CORRECT_REJECT_MAIL_ADDRESS = (
  sourceID,
  sourceTypeID,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondence/get-mailing-address/${sourceID}/${sourceTypeID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_CORRESPONDENCE_SOURCE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceType/GetAllActive`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

// export const FETCH_CORRESPONDENCE_AMENDMENT_TYPES = (sourceTypeID, callback, errorCallback) => {
//   fetchAndCatch(
//     {
//       url: `/api/CustomCorrespondence/GetAmendmentTypes/${sourceTypeID}`,
//       method: 'GET',
//     },
//     callback,
//     errorCallback
//   )
// }

export const FETCH_WEB_USER_INFO = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Web-User/GetWebUser/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_WEB_USER_RIGHTS_OPTIONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Web-User/GetWebUserRights`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const ADD_RECEIPT_ITEM = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/AddReceiptItem`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_RECEIPT_NUM_BY_IMAGE_GROUP_ID = (imageGroupId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/GetReceiptNumByImageGroupId/${imageGroupId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RECEIPT_BY_SOURCE_TYPE_ID_SOURCE_ID = (
  sourceTypeId,
  sourceId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/receipt/GetReceiptBySourceTypeIdSourceId/${sourceTypeId}/${sourceId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_ASSOCIATED_AMENDMENT = (DLN, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/delete/DeleteAssociatedAmendment/` + DLN,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

// export const GENERATE_WEB_USER_ACTIVITY_REPORT = (from, through, callback, errorCallback) => {
//   fetchAndCatch({

//   })
// }

export const FETCH_UCC_INFO_REQUEST_DATA = (num, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestRecordDetails/GetRecordDetails/${num}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_INFO_REQ_NOTES = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfo/GetNotes/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_UCC_DOCUMENT_NOTES = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Note/GetNotes/2000/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_INFO_REQUEST_FILINGS_SERVER_PAGINATED = (
  infoRequestNum,
  pageNum,
  pageSize,
  sortField,
  sortDirection,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: encodeURI(
        `/api/UCCInfoRequestRecordDetails/GetFilings?InfoRequestNum=${infoRequestNum}&PageNum=${pageNum}&PageSize=${pageSize}${
          sortField ? `&SortField=${sortField}` : ''
        }${sortDirection ? `&SortDirection=${sortDirection}` : ''}`
      ),
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_INFO_REQUEST_FILINGS_COUNT = (infoRequestNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfoRequestRecordDetails/GetFilingsCount?InfoRequestNum=${infoRequestNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const VOID_RECEIPT = (receipt, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/receipt/VoidDeleteReceipt`,
      method: 'POST',
      body: JSON.stringify(receipt),
    },
    callback,
    errorCallback
  )
}

export const FETCH_ENTITY_NOTES = (sourceType, id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Note/GetNotes/${sourceType}/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_NOTE = (sourceTypeID, sourceID, noteText, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Note/CreateNote`,
      method: 'POST',
      body: JSON.stringify({
        SourceTypeID: sourceTypeID,
        SourceID: sourceID,
        NoteTypeID: 3,
        NoteText: noteText,
      }),
    },
    callback,
    errorCallback
  )
}

export const EDIT_NOTE = (note, callback, errorCallback) => {
  if (note.NoteType.LastModifiedByName == null || !!note.NoteType.LastModifiedByName)
    note.NoteType.LastModifiedByName = ''
  fetchAndCatch(
    {
      url: `/api/Note/EditNote`,
      method: 'PUT',
      body: JSON.stringify({
        ...note,
      }),
    },
    callback,
    errorCallback
  )
}

export const DELETE_NOTE = (noteId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Note/DeleteNote/${noteId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_NOTE_HISTORY = (noteId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NoteHistory/GetByNoteId/${noteId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RECONCILE_USERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Batch/GetReconcileUsers`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_PAYMENT_BATCHES = (appUserID, batchTypeID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Batch/GetPaymentCounts/${appUserID}/${batchTypeID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const RECONCILE_BATCH = (batch, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/batch/batch`,
      method: 'POST',
      body: JSON.stringify(batch),
    },
    callback,
    errorCallback
  )
}

export const GET_BATCH_REPORT = (userID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Batch/GetBatchReport/${userID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_PRINTABLE_BATCH_REPORT = (userID, batchNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Batch/GetPrintableBatchReport/${userID}/${batchNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UNRECONCILE_USERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Batch/GetUnReconcileUsers`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RECONCILED_BATCHES = (appUserID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Batch/GetUnReconcileRecords/${appUserID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UNRECONCILE_BATCH = (batches, appUserID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/batch/Unreconcile/${appUserID}`,
      method: 'POST',
      body: JSON.stringify(batches),
    },
    callback,
    errorCallback
  )
}

export const GET_BATCH_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostDistribution/GetGetBatchTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_POST_PAYMENT_REPORT_DEF = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostPaymentBatch/GetReportData`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_POST_PAYMENT_BATCHES = (type, throughDate, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostPaymentBatch/GetPaymentBatches/${type}/${throughDate}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const POST_TO_GET_PAYMENT_BATCHES_FOR_POST = (batchList, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostPaymentBatch/GetPaymentBatches/GetPayments`,
      method: 'POST',
      body: JSON.stringify(batchList),
    },
    callback,
    errorCallback
  )
}

export const POST_PAYMENT_BATCHES = (batchList, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostPaymentBatch/PostBatches`,
      method: 'POST',
      body: JSON.stringify(batchList),
    },
    callback,
    errorCallback
  )
}

export const GET_POST_BATCH_REPORT = (depositNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostPaymentBatch/GetReports/${depositNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DIST_PAYMETS = (type, throughDate, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostDistribution/GetPayments/${type}/${throughDate}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DIST_REPORTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostDistribution/GetReportData`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const POST_DIST = (batchType, date, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostDistribution/PostDist/${batchType}/${date}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const GET_DIST_POST_REPORT = (batchNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostDistribution/GetReports/${batchNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CORRESPONDENCE_ITEM_AMENDMENT = (
  imageDataTypeID,
  sourceNum,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/AmendmentType/${imageDataTypeID}/${sourceNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_UCC_INFO_REQUEST_AS_FULFILLED = (uccInfoNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCInfo/FulfillUCCInfo/${uccInfoNum}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const ADD_TO_PRINT_QUEUE = (reportInfo, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/printqueue/add`,
      method: `POST`,
      body: window.btoa(JSON.stringify(reportInfo)),
      contentType: 'text/plain',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_TOTALS = (WorkViewID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetTotals/${WorkViewID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_CATEGORY_TOTALS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetCategoryTotals`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

// startDate format: mm-dd-yyyy
export const GET_DASHBOARD_GRAPH_DATA = (sourceTypeID, startDate, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetGraphData/${sourceTypeID}/${startDate}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_LAST_DAYS = (WorkViewID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetLastDays/${WorkViewID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_CURRENT_MONTH = (WorkViewID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetCurrentMonth/${WorkViewID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_CURRENT_YEAR = (WorkViewID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetCurrentYear/${WorkViewID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_LAST_YEARS = (WorkViewID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetLastYears/${WorkViewID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_QUEUE_DATA = (WorkViewID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetCurrentQueueValues/${WorkViewID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

//#region Print Queue
export const GET_PRINT_QUEUE_COUNT = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/printqueue/GetUserPrintQueueCount`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const EXPORT_PRINT_QUEUE_ITEMS_TO_PDF = (entryIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/printqueue/ExportToPDF/${entryIds.join(',')}`,
      method: 'GET',
      body: entryIds,
    },
    callback,
    errorCallback
  )
}

export const PRINT_QUEUE_ENTRIES = (entryIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/printqueue/ExportToZip/${entryIds.join(',')}`,
      method: 'GET',
      body: entryIds,
      raw: true,
    },
    callback,
    errorCallback
  )
}

export const PRINT_QUEUE_MARK_AS_FULFILLED = (entryIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/printqueue/markAsFulfilled`,
      method: 'POST',
      body: JSON.stringify(entryIds),
    },
    callback,
    errorCallback
  )
}

export const DELETE_PRINT_QUEUE_ENTRIES = (entryIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/printqueue/${entryIds.join(',')}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_PRINT_QUEUE_DATA = (
  batchSize,
  userId,
  queueType,
  methodOfReturn,
  pageNumber,
  sortColumn,
  sortDirection,
  searchText,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: encodeURI(
        `/api/printqueue/Get/${batchSize || 25}/${pageNumber || 0}?${`requestedUserId=${
          userId || 0
        }`}${queueType ? `&entryType=${queueType}` : ''}${
          methodOfReturn ? `&methodOfReturnType=${methodOfReturn}` : ''
        }${sortColumn ? `&sortByColumn=${sortColumn}` : ''}${
          sortDirection ? `&sortByDesc=${sortDirection}` : ''
        }${searchText ? `&compare=${searchText}` : ''}`
      ),
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_PRINT_QUEUE_USERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/PrintQueue/GetPrintQueueUsers',
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
//#endregion

export const GET_PROCESSED_THROUGH_DATES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FileThroughDate`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_USER_PRODUCTIVITY_DATA = (
  userAppID,
  startDate,
  endDate,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetProductivityLog/${userAppID}/${startDate}/${endDate}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_DATED_USER_PRODUCTIVITY_DATA = (
  userAppID,
  workviewID,
  submitTypeID,
  startDate,
  endDate,
  breakdownScale,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Dashboard/GetProductivityUserData/${userAppID}/${workviewID}/${submitTypeID}/${startDate}/${endDate}/${breakdownScale}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_IMAGE_BY_DLN = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Image/DeleteImages`,
      method: 'POST',
      body: JSON.stringify([dln]),
    },
    callback,
    errorCallback
  )
}

export const UNREDACT_IMAGE_BY_DLN = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/RemoveRedaction`,
      method: 'POST',
      body: JSON.stringify([dln]),
    },
    callback,
    errorCallback
  )
}

export const GET_IS_ORIGINAL_IMAGE = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImageEnvelope/ImageDefault/${dln}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const REGENERATE_FILED_STAMP = (dln, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Image/RegenerateFiledStamp/${dln}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const DOES_IMAGE_ENVELOPE_HAVE_PAYMENT = (imageEnvelopeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/DoesImageEnvelopeHavePayment/${imageEnvelopeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CORRECTION_INFO = (correspondenceNumber, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetCorrectionInfo/${correspondenceNumber}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const MERGE_CORRECTION = (correspondenceNumber, newDLN, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/MergeCorrection`,
      method: 'POST',
      body: JSON.stringify({ correspondenceNumber, newDLN }),
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_RECORD_DETAILS = (commissionNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordDetails/${commissionNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_RECORD_DETAIL_HISTORY = (commissionNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordDetails/notary-history/${commissionNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const FETCH_DATA_REQUEST_RECORD_DETAILS = (dataRequestFilingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataRequestRecordDetail/GetRecordDetails/${dataRequestFilingId}`, // update from alex.
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const LOAD_STAFF_WIZARD_DRAFT_BY_ID = (imageGroupID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/StaffDrafts/GetDraft/${imageGroupID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_STAFF_WIZARD_DRAFT = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/StaffDrafts/SaveDraft`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const DELETE_STAFF_WIZARD_DRAFT_BY_ID = (draftId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/StaffDrafts/DeleteDraft/${draftId}`,
      method: 'POST',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_STAFF_DRAFT_EXISTS_BY_ID = (imageGroupID, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/StaffDrafts/GetDraftExists/${imageGroupID}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const LOAD_STAFF_FILING_CORRECTION_WIZARD = (
  filingNum,
  recordNum,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ucc/filing/staffCorrection/${filingNum}/${recordNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_STATES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/State/GetStates/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_STATE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/State/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_STATES = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/State`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_STATE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/State`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_COUNTIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/County/GetCounties/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_COUNTY_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/County/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_COUNTIES = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/County`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_COUNTIES = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/County`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_COUNTRIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Country/GetCountries/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_COUNTRY_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Country/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_COUNTRIES = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Country`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_COUNTRIES = (obj, method, callback, errorCallback) => {
  if (!obj.IsHagueConvention) obj.IsHagueConvention = false

  fetchAndCatch(
    {
      url: `/api/Country`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_POSTAL_CODES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostalCode/GetPostalCodes/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_POSTAL_CODE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostalCode/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_POSTAL_CODES = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostalCode`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_POSTAL_CODES = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/PostalCode`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_LOOKUP_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LookupType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_LOOKUP_TYPE_ENUM = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LookupTypeEnum/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_LOOKUP_TYPE_ENUM_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LookupTypeEnum/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_SOURCE_TYPE = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_BOND_COMPANIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryBondCompany/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_BOND_COMPANY_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryBondCompany/GetCompanyById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_NOTARY_BOND_COMPANY = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryBondCompany/DeleteByIds`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_NOTARY_BOND_COMPANY = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryBondCompany/${method === 'PUT' ? `Update` : `Insert`}NotaryBondCompany`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_COMPLAINT_TYPE = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_NOTARY_COMPLAINT_TYPES = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintType/Create/${obj.Name}`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_COMPLAINT_REASONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintReasonType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_COMPLAINT_REASON_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintReasonType/GetComplaintReasonById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_NOTARY_COMPLAINT_REASONS = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintReasonType/DeleteByIds`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const SAVE_NOTARY_COMPLAINT_STATUS_TYPES = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintReasonType/`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_COMPLAINT_REASON_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintReasonType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_COMPLAINT_STATUS_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintStatusType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_COMPLAINT_STATUS_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintStatusType/GetComplaintStatusById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_NOTARY_COMPLAINT_STATUS = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintStatusType/`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_NOTARY_COMPLAINT_STATUS = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryComplaintReasonType/DeleteByIds`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_STATUS_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryStatusType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_NOTARY_STATUS_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryStatusType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_RECEIPT_ITEM_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemType/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_RECEIPT_ITEM_TYPE_BY_ID = (itemId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemType/GetById/${itemId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_RECEIPT_ITEM_TYPE = (item, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemType`,
      method: method,
      body: JSON.stringify(item),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_CUSTOM_CORRESPONDENCE_REASONS = (
  sourceTypeId,
  recordTypeId,
  recordSubTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondenceReasonType/GetList/${sourceTypeId}/${recordTypeId}/${filingTypeId}/${
        recordSubTypeId
          ? recordSubTypeId === 'null'
            ? ''
            : recordSubTypeId
          : recordSubTypeId === 0
          ? 0
          : ''
      }`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISCELLANEOUS_SETTINGS_CUSTOM_CORRESPONDENCE_REASONS = (
  sourceTypeId,  
  miscellaneousModuleId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondenceReasonType/GetMiscellaneousList/${sourceTypeId}/${miscellaneousModuleId}/${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_CUSTOM_CORRESPONDENCE_REASON_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondenceReasonType/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_CUSTOM_CORRESPONDENCE_REASON = (
  obj,
  method,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondenceReasonType/`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_CUSTOM_CORRESPONDENCE_REASONS = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CustomCorrespondenceReasonType/`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const GET_APPLICATION_SETTING_CATEGORIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceType/GetAllFiling/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SOURCE_TYPE_OPTIONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceType/GetAllFiling/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SOURCE_TYPE_WITH_EDITABLE_RECORD_DETAIL = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceType/GetAllRecordDetailSettings/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ACTIVE_BASIC_LOOKUP_TYPES = (moduleName, lookupType, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${moduleName + lookupType}/GetActiveBasicLookupTypes/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WORK_VIEW_STATUSES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ProcessingStatusType/GetWorkViewStatuses/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ACTIVE_BASIC_LOOKUP_TYPES_OPTIONS = (
  moduleName,
  lookupType,
  options,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/${moduleName + lookupType}/GetActiveBasicLookupTypes/`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_BASIC_LOOKUP_TYPES = (lookupType, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${lookupType}/GetAllBasicLookupTypes/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ADDITIONAL_ORDER_PARAMS = (id, options, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderXref/GetAdditionalOrderParamsBySourceType/${id}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_ENUM_LOOKUP_TYPE = (lookupEnumType, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${lookupEnumType}/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_NOTARY_RECORD_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_NOTARY_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_NOTARY_FILING_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryFilingType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_UCC_RECORD_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCRecordType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_UCC_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_UCC_FILING_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_UCC_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_UCC_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LienType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_UCC_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LienType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_UCC_STATUS_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCStatusType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_UCC_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UCCStatusType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_FILING_TYPE = (method, obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessFilingType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_RECORD_TYPE = (method, obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_RECORD_SUB_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordSubType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_RECORD_SUB_TYPE = (method, obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordSubType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessStatusType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_STATUS_TYPE = (method, obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessStatusType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_PARTY_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessPartyType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_PARTY_TYPE = (method, obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessPartyType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_PARTY_TITLE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessPartyTitle/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_PARTY_TITLE = (method, obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessPartyTitle`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_USER_PASSWORD = (obj, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Users/UpdateUserPassword`,
      method: 'POST',
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_APP_USERS_PAGINATED = (
  pageNum,
  includeAllUsers,
  searchText,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: encodeURI(
        `/api/Users/GetUsersPaginated/${pageNum}/${includeAllUsers}${
          searchText ? `?searchText=${encodeURIComponent(searchText)}` : ''
        }`
      ),
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_APP_USERS = (includeAllUsers, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Users/GetUsers/${includeAllUsers}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_APP_USERS_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Users/${id}/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_APP_USERS = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Users`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_SOFTWARE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryService/GetSoftwareTypes/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SOFTWARE_PROVIDERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryService/GetSoftwareProviders`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SOFTWARE_PROVIDER = (itemId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryService/GetSoftwareProvider/${itemId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_SOFTWARE_PROVIDER = (editItem, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryService/PostSoftwareProvider/`,
      method: 'POST',
      body: JSON.stringify(editItem),
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_RECEIPT_ITEM_TYPES = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_RECORD_BY_FILING_ID = (filingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Notary/getByFilingId/${filingId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_PREPARED_RECEIPT_BALANCED = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/WebPreparedReceiptBalanced/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_PROCESS_MODAL_FIELDS = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Workview/GetWebProcessModalFields/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_GL_ACCOUNT_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/GeneralLedgerAccount/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_GENERAL_LEDGER_ACCOUNT_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/GeneralLedgerAccount/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_GENERAL_LEDGER_ACCOUNT = (item, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/GeneralLedgerAccount`,
      method: method,
      body: JSON.stringify(item),
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_NOTARY_RECORD_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryRecordType/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_RECORD_OWNER_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordOwnerType/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ALL_ACCESS_CONTROL_ROLES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserRole/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ALL_ACTIVE_ACCESS_CONTROL_ROLES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserRole/GetActive`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_NOTARY_FILING_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryFilingType/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ROLE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserRole/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_ACCESS_CONTROL_ROLE = (role, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserRole`,
      method,
      body: JSON.stringify(role),
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_NOTARY_STATUS_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryStatusType/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_ACCESS_CONTROL_ROLE = (role, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppRole`,
      method: 'DELETE',
      body: JSON.stringify(role),
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_IMAGE_PAGE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/GetAllImagePageBasicTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_IMAGE_PAGE_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_IMAGE_PAGE_TYPE_CATEGORIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/Categories`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_IMAGE_PAGE_TYPE_ADDITIONAL_PAGE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/AdditionalPageTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const GET_SETTINGS_IMAGE_PAGE_TYPE_AZURE_STORAGE_ACCOUNTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/AzureStorageAccounts`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_IMAGE_PAGE_TYPE_CLASSIFICATION_CATEGORIES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/ClassificationCategories`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_IMAGE_PAGE_TYPE_CLASSIFICATION_GROUPS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType/ClassificationGroups`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_IMAGE_PAGE_TYPE = (data, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ImagePageType`,
      method: 'POST',
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_RECORD_STATUSES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NotaryStatusType/GetAllBasicLookupTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ALL_ACCESS_CONTROL_RIGHTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/UserRight/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_FORMS_BY_CATEGORY = (category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/GetAllByCategory/${category}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_APP_REPORTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppReport/GetAppReports`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_FILING_TO_RECORD_XREF_BY_ID = (recordTypeId, callback, errorCallback) => {
  if (recordTypeId)
    fetchAndCatch(
      {
        url: `/api/NotaryFilingTypeXref/GetFilingTypeIdsByRecordType/${recordTypeId}`,
        method: 'GET',
      },
      callback,
      errorCallback
    )
}

export const GET_NOTARY_FILING_TO_RECORD_XREF_BY_TYPES = (
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  if (recordTypeId && filingTypeId)
    fetchAndCatch(
      {
        url: `/api/NotaryFilingTypeXref/GetFilingTypeIdsByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
        method: 'GET',
      },
      callback,
      errorCallback
    )
}

export const DELETE_NOTARY_FILING_TO_RECORD_XREF_BY_ID = (
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/NotaryFilingTypeXref/${recordTypeId}/${filingTypeId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const ADD_NOTARY_FILING_TO_RECORD_XREF = (data, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/NotaryFilingTypeXref',
      method: 'POST',
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const EDIT_NOTARY_FILING_TO_RECORD_XREF = (data, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/NotaryFilingTypeXref',
      method: 'PUT',
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const CREATE_CYBERSOURCE_WEB_CART = (itemIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/CreateWebCart`,
      method: 'POST',
      body: JSON.stringify(itemIds),
    },
    callback,
    errorCallback
  )
}

// Wallet API's own create-cart wrapper. Same endpoint, but kept under a Wallet-specific name
// so the Wallet flow does not reference other payment providers' function names.
export const CREATE_WALLET_WEB_CART = (itemIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/CreateWebCart`,
      method: 'POST',
      body: JSON.stringify(itemIds),
    },
    callback,
    errorCallback
  )
}

export const MAKE_PAYMENT_TRANSACTION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/MakeTransaction`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const SUBMIT_TT_NON_SAVED_PAYMENT = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/SubmitTTNonSavedPayment/${refNum}`,
      method: 'POST',
      /*body: JSON.stringify(payload),*/
    },
    callback,
    errorCallback
  )
}

export const SUBMIT_TT_SAVED_PAYMENT = (refNum, userPaymentInfo, nachaAgreementGuid, callback, errorCallback) => {
  const query = nachaAgreementGuid
    ? `?nachaAgreementGuid=${encodeURIComponent(nachaAgreementGuid)}`
    : ''
  fetchAndCatch(
    {
      url: `/api/Payment/SubmitTTSavedPayment/${refNum}${query}`,
      method: 'POST',
      body: JSON.stringify(userPaymentInfo),
    },
    callback,
    errorCallback
  )
}

export const ADD_USER_PAYMENT_INFO = (walletId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/AddUserPaymentInfo/${walletId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

// Wallet API: register the just-added payment method. Passes the account Ids that existed
// before the add so the server can deterministically identify the new account (see
// GetAddedAccount). Kept separate from ADD_USER_PAYMENT_INFO so the wallet flow stays
// decoupled from the other providers' checkout.
export const ADD_WALLET_USER_PAYMENT_INFO = (walletId, existingIds, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/AddUserPaymentInfo/${walletId}`,
      method: 'POST',
      body: JSON.stringify(existingIds || []),
    },
    callback,
    errorCallback
  )
}

export const LIST_MY_SAVED_PAYMENT_METHODS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/ListMySavedPaymentMethods`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SAVED_PAYMENT_METHOD = (walletId, paymentAccountId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/DeleteSavedPaymentMethod/${walletId}/${paymentAccountId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_NACHA_AGREEMENT = (refNum, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/GetNachaAgreement/${refNum}`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_CART_STATUS = (webCartNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/WebCartStatus/${webCartNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_APOSTILLE_RECORD_DETAILS = (apostilleNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ApostilleRecordDetails/${apostilleNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FACSIMILE_SIGNATURE_DETAILS = (facsimileNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FacsimileRecordDetails/${facsimileNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_EDIT_RECORD_URL = (name, recordNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${name}/GetRedirectUrl/${recordNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES = (
  sourceTypeId,
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemTypeXref/GetXrefs?sourceTypeId=${sourceTypeId}&recordTypeId=${recordTypeId}&filingTypeId=${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_SUB_TYPE = (
  sourceTypeId,
  recordTypeId,
  filingTypeId,
  recordSubTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemTypeXref/GetXrefs/${sourceTypeId}/${recordTypeId}/${filingTypeId}${
        recordSubTypeId && +recordSubTypeId !== 0 ? `/${recordSubTypeId}` : ''
      }`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_MISCELLANEOUS = (
  sourceTypeId,
  miscellaneousModuleId,
  filingTypeId,  
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemTypeXref/GetMiscellaneousXrefs/${sourceTypeId}/${miscellaneousModuleId}/${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_ORDERS = (
  sourceTypeId,
  orderSourceTypeId,
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemTypeXref/GetOrderXrefs/${sourceTypeId}/${orderSourceTypeId}/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_RECEIPT_ITEM_TYPE_XREF = (dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ReceiptItemTypeXref/SaveXrefs`,
      method: 'POST',
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_UCC_FILING_TYPE_IDS_BY_RECORD_TYPE = (
  options,
  recordTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingTypeXref/GetFilingTypeIdsByRecordType/${recordTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_UCC_FILING_TO_RECORD_XREF = (
  options,
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_UCC_FILING_TYPE_RECORD_TYPE_XREF = (
  method,
  dto,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingTypeXref`,
      method,
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_UCC_FILING_TYPE_RECORD_TYPE_XREF = (
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/UCCFilingTypeXref/${recordTypeId}/${filingTypeId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_REGULATED_WORD_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWordType/GetAllActive`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_REGULATED_WORDS_BY_SOURCE_TYPE = (
  sourceTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord/GetAll/${sourceTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_REGULATED_WORD_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord/GetById/${id}/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_REGULATED_WORD = (method, dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord`,
      method,
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_REGULATED_WORDS_BY_TYPES = (
  sourceTypeId,
  recordType,
  recordSubType,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord/GetAll/${sourceTypeId}/${recordType}/${recordSubType}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_REGULATED_WORDS_BY_TYPES_AND_CATEGORY = (
  sourceTypeId,
  recordType,
  recordSubType,
  wordType,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord/GetByType/${wordType}/${sourceTypeId}/${recordType}/${recordSubType}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_REGULATED_WORDS = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE = (
  recordTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordSubTypeXref/GetById/${recordTypeId}/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_RECORD_SUB_TYPE_XREF = (dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordSubTypeXref/Save`,
      method: 'POST',
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_FILING_TO_RECORD_XREF = (
  options,
  recordTypeId,
  recordSubTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/BusinessFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}${
        recordSubTypeId ? `/${recordSubTypeId}` : ``
      }`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_BUSINESS_FILING_TYPE_IDS_BY_RECORD_TYPE_SUB_TYPE = (
  options,
  recordTypeId,
  recordSubTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/BusinessFilingTypeXref/GetFilingTypeIdsByRecordType/${recordTypeId}${
        recordSubTypeId ? `/${recordSubTypeId}` : ``
      }`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_FILING_TYPE_RECORD_TYPE_XREF = (
  method,
  dto,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/BusinessFilingTypeXref`,
      method,
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_BUSINESS_FILING_TYPE_RECORD_TYPE_XREF = (
  businessFilingTypeXrefId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/BusinessFilingTypeXref/${businessFilingTypeXrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_TRADEMARK_FILING_TO_RECORD_XREF = (
  options,
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_TRADEMARK_FILING_TYPE_IDS_BY_RECORD_TYPE = (
  options,
  recordTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkFilingTypeXref/GetFilingTypeIdsByRecordType/${recordTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_FILING_TYPE_RECORD_TYPE_XREF = (
  method,
  dto,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkFilingTypeXref`,
      method,
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_TRADEMARK_FILING_TYPE_RECORD_TYPE_XREF = (
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkFilingTypeXref/${recordTypeId}/${filingTypeId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_PROCESSED_THROUGH_DATES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ProcessedThroughDate/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const GET_PROCESSED_THROUGH_DATE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ProcessedThroughDate/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_PROCESSED_THROUGH_DATE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ProcessedThroughDate`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const DELETE_PROCESSED_THROUGH_DATE = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ProcessedThroughDate`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const GET_PROCESSED_THROUGH_DATE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ProcessedThroughDateType/GetAll`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_FREQUENT_PAYOR_ACCOUNTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FrequentPayorAdmin/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FrequentPayorAdmin/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_FREQUENT_PAYOR = (updating, frequentPayor, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FrequentPayorAdmin/`,
      method: updating ? 'PUT' : 'POST',
      body: JSON.stringify(frequentPayor),
    },
    callback,
    errorCallback
  )
}

export const SAVE_STAFF_FILING_CORRECTION = (json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ucc/filing/staffCorrection`,
      method: 'POST',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const VALIDATE_BLACK_BOX = (json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/risk-checks`,
      method: 'POST',
      body: JSON.stringify(json),
    },
    callback,
    errorCallback
  )
}

export const GET_CSV_FROM_SEARCH = (path, json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${path}/GenerateCSV`,
      method: 'POST',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ORDER_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  //OrderFilingType
  fetchAndCatch(
    {
      url: `/api/OrderFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_ORDER_FILING_TYPE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderFilingType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const GET_CONFIGURED_ORDER_SOURCE_TYPES = (
  includeVerificationTypes,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/OrderXref/GetConfiguredOrderSourceTypes/${includeVerificationTypes}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CERTIFY_ORDER = (sourceType, orderNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CertifyOrder/${sourceType}/${orderNum}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ALL_BUSINESS_CONVERSION_TYPES_XREF = (
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ConversionTypesXref/GetAll/${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_CONVERSION_TYPE_XREF = (
  data,
  method,
  callback,
  errorCallback
) => {
  // This is used for save, update, AND delete
  fetchAndCatch(
    {
      url: `/api/ConversionTypesXref`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const DELETE_CONVERSION_TYPE_XREF = (
  ConversionRecordTypeXrefId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/ConversionTypesXref/${ConversionRecordTypeXrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ALL_BUSINESS_MERGER_TYPES_XREF = (
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/MergerConfigurationXref/GetAll/${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_BUSINESS_MERGER_TYPE_XREF = (data, method, callback, errorCallback) => {
  // This is used for save, update, AND delete
  fetchAndCatch(
    {
      url: `/api/MergerConfigurationXref`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const DELETE_MERGER_TYPE_XREF = (ConversionRecordTypeXrefId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MergerConfigurationXref/${ConversionRecordTypeXrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_FORM_PERMISSIONS_BY_ID = (itemId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinitionAccess/GetByFormId/${itemId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_FORM_PERMISSIONS = (data, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinitionAccess/UpdateByFormId`,
      method: 'POST',
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

//#region Order XRef
export const GET_ORDERS_XREF = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderXRef/GetAll`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const CREATE_NEW_ORDER_XREF = (json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderXRef/Create`,
      method: 'POST',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const UPDATE_ORDER_XREF = (json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderXRef/Update`,
      method: 'PUT',
      body: JSON.stringify(json),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const DELETE_ORDER_XREF = (orderXrefId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/OrderXRef/Delete/${orderXrefId}`,
      method: 'DELETE',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_SOURCE_TYPES_FOR_DROPDOWNS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceTypeDropDown/GetAllSourceTypesForDropDowns`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_DROPDOWN_OPTIONS_USING_SOURCETYPE = (sourceTypeCode, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceTypeDropDown/GetWizardDropDownOptions/${sourceTypeCode}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_DROP_DOWN_OPTION_BY_ID = (DropDownOptionsSourceId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SourceTypeDropDown/GetDropdownOption/${DropDownOptionsSourceId}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Trademark Filing Types Setting
export const GET_SETTINGS_TRADEMARK_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_FILING_TYPE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkFilingType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Trademark Record Types Setting
export const GET_SETTINGS_TRADEMARK_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_RECORD_TYPE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkRecordType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Trademark Applicant Types Setting
export const GET_SETTINGS_TRADEMARK_APPLICANT_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkApplicantType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_APPLICANT_TYPE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkApplicantType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Trademark Applicant Org Types Setting

export const GET_SETTINGS_TRADEMARK_APPLICANT_ORG_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkApplicantOrgType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_APPLICANT_ORG_TYPE = (
  data,
  method,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkApplicantOrgType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Trademark Class Type Setting
export const GET_SETTINGS_TRADEMARK_CLASS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkClassType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_CLASS_TYPE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkClassType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

export const GET_TRADEMARK_CLASS_TYPES_BY_RECORD_TYPE = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkClassType/GetOnRecordTypeId/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Trademark Status Types Setting
export const GET_SETTINGS_TRADEMARK_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkStatusType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_TRADEMARK_STATUS_TYPE = (data, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkStatusType`,
      method,
      body: JSON.stringify(data),
    },
    callback,
    errorCallback
  )
}

//#endregion

//#region OIDC
export const OIDC_VALUE = (userType, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiLogin/oidc-settings?bucket=${userType}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const OIDC_TOKEN_GET = (code, userType, callback, errorCallback) => {
  let body = JSON.stringify({ code: code, userType: userType })
  fetchAndCatch(
    {
      url: `/api/MiLogin/jwt`,
      method: 'POST',
      body: body,
    },
    callback,
    errorCallback
  )
}
export const REFRESH_MILOGIN = (staleCode, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiLogin/refresh?staleToken=${staleCode}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Setting Page Config
export const GET_SETTING_PAGES_CONFIG = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SettingsPages`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTING_PROPERTIES_BY_PAGE_ID = (pageId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SettingsPages/GetProperties/${pageId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
//#endregion

export const GET_SIGNER_CAPACITY_TYPES_BY_SOURCE_TYPE_ID = (id = 0, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SignerCapacityType/SourceTypeId/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SIGNER_CAPACTITY_TYPES_SETTINGS = (id = 0, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SignerCapacityType/Settings/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SIGNER_CAPACITY_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SignerCapacityType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_SIGNER_CAPACITY_TYPE = (obj, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SignerCapacityType`,
      method,
      body: JSON.stringify(obj),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_SIGNER_CAPACITY_TYPE = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SignerCapacityType/DeleteByIds`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

//#region Settings Import Export
export const GET_SETTINGS_EXPORT_PAGES = (callback, errorCallback) => {
  //SettingsPagesExport
  fetchAndCatch(
    {
      url: `/api/SettingsPage`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_EXPORT_JSON = (ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SettingsPage/Export?settingPageIds=${ids.join()}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const IMPORT_SETTINGS_JSON = (json, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/SettingsPage/Import`,
      method: 'POST',
      body: JSON.stringify(json),
    },
    callback,
    errorCallback
  )
}
//#endregion
//#region Trademark Crop
export const CROP_TRADEMARK_SPECIMEN = (imageNum, rect, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkThumbnail/CropImage/${imageNum}`,
      method: 'POST',
      body: JSON.stringify(rect),
    },
    callback,
    errorCallback
  )
}

export const GET_TRADEMARK_THUMBNAIL = (thumbnailId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkThumbnail/GetThumbnailImage/${thumbnailId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SET_TRADEMARK_TO_IMAGE_CROP = (workViewItemId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkThumbnail/SetToImageCrop/${workViewItemId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}

export const SET_TRADEMARK_TO_PENDING_PAYMENT = (workViewItemId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/TrademarkThumbnail/SetToPendingPayment/${workViewItemId}`,
      method: 'POST',
    },
    callback,
    errorCallback
  )
}
//#endregion
//#region Registered Agent Settings
export const GET_RA_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_RA_RECORD_TYPE = (type, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentRecordType`,
      method: 'PUT',
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}
export const GET_RA_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_RA_FILING_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentFilingType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}
export const GET_RA_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentStatusType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_RA_STATUS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentStatusType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}
export const GET_RA_XREF_FILING_TYPE_IDS_BY_RECORD_TYPE = (
  options,
  recordType,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentFilingTypeXref/GetFilingTypeIdsByRecordType/${recordType}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}
export const GET_RA_XREF_BY_RECORD_TYPE_FILING_TYPE = (
  options,
  recordType,
  filingType,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordType}/${filingType}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}
export const SAVE_RA_FILING_TYPE_XREF = (method, xref, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentFilingTypeXref`,
      method,
      body: JSON.stringify(xref),
    },
    callback,
    errorCallback
  )
}
export const DELETE_RA_FILING_TYPE_XREF = (recordType, filingType, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegisteredAgentFilingTypeXref/${recordType}/${filingType}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_ANNUAL_REPORT_MONTH_DUE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/BusinessRecordType/GetARMonthDueTypeForDropDowns`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Athlete Agent Settings
export const GET_ATHLETE_AGENT_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_ATHLETE_AGENT_RECORD_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentRecordType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_ATHLETE_AGENT_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentFilingType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_ATHLETE_AGENT_FILING_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentFilingType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_ATHLETE_AGENT_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentStatusType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_ATHLETE_AGENT_STATUS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentStatusType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_ATHLETE_AGENT_FILING_TYPE_IDS_BY_RECORD_TYPE = (
  options,
  recordTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentFilingTypeXref/GetFilingTypeXrefIdsByRecordType/${recordTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}
export const GET_SETTINGS_ATHLETE_AGENT_XREF_BY_RECORD_TYPE_FILING_TYPE = (
  options,
  recordTypeId,
  filingTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}
export const SAVE_SETTINGS_ATHLETE_AGENT_FILING_TYPE_XREF = (
  method,
  xref,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentFilingTypeXref`,
      method,
      body: JSON.stringify(xref),
    },
    callback,
    errorCallback
  )
}
export const DELETE_SETTINGS_ATHLETE_AGENT_FILING_TYPE_XREF = (xrefId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AthleteAgentFilingTypeXref/${xrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}
export const GET_ATHLETE_AGENT_RECORD_DETAILS = (recordNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FilingDetail/athleteAgentStaff/${recordNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}
//#endregion

//#region Service of Process Settings
export const GET_SERVICE_OF_PROCESS_STATUTE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ServiceOfProcessStatute/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_SERVICE_OF_PROCESS_STATUTE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ServiceOfProcessStatute`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}
export const GET_SERVICE_OF_PROCESS_COURT_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ServiceOfProcessCourt/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
export const UPDATE_SERVICE_OF_PROCESS_COURT = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ServiceOfProcessCourt`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}
export const GET_SERVICE_OF_PROCESS_FILING_DETAILS = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FilingDetail/serviceOfProcessStaff/${filingNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}
//#endregion

export const GET_CHARITY_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityFilingType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CHARITY_FILING_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityFilingType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CHARITY_STATUS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityStatusType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_CHARITY_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityStatusType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CHARITY_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CHARITY_RECORD_TYPE = (method, type, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityRecordType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

// #region Charity Filing Type Xref
export const GET_SETTINGS_CHARITY_FILING_TYPE_IDS_BY_RECORD_TYPE = (options, recordTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityFilingTypeXref/GetFilingTypeXrefIdsByRecordType/${recordTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_CHARITY_FILING_TYPE_XREF = (method, xref, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityFilingTypeXref`,
      method,
      body: JSON.stringify(xref),
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_CHARITY_FILING_TYPE_XREF = (xrefId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityFilingTypeXref/${xrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_CHARITY_XREF_BY_RECORD_TYPE_FILING_TYPE = (options, recordTypeId, filingTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/CharityFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
      ...options
    },
    callback,
    errorCallback
  )
}
// #endregion
// #region Contractor Settings
export const GET_CONTRACTOR_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorFilingType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_FILING_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorFilingType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_STATUS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorStatusType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorStatusType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorRecordType/GetTypeById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_RECORD_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorRecordType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_CLASS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorClassType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_CLASS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorClassType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_COMPLAINT_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_COMPLAINT_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_COMPLAINT_TYPES_FOR_REASONS_SETTINGS_PAGE = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintType/GetAll/`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_COMPLAINT_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintStatusType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_COMPLAINT_STATUS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintStatusType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_COMPLAINT_REASON_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintReasonType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_CONTRACTOR_COMPLAINT_REASON_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorComplaintReasonType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_SETTINGS_CONTRACTOR_FILING_TYPE_IDS_BY_RECORD_TYPE = (options, recordTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorFilingTypeXref/GetFilingTypeXrefIdsByRecordType/${recordTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_CONTRACTOR_FILING_TYPE_XREF = (method, xref, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorFilingTypeXref`,
      method,
      body: JSON.stringify(xref),
    },
    callback,
    errorCallback
  )
}


export const DELETE_SETTINGS_CONTRACTOR_FILING_TYPE_XREF = (xrefId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorFilingTypeXref/${xrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}


export const GET_SETTINGS_CONTRACTOR_XREF_BY_RECORD_TYPE_FILING_TYPE = (options, recordTypeId, filingTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ContractorFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
      ...options
    },
    callback,
    errorCallback
  )
}
// #endregion
// #region Lobbyist Settings
export const GET_LOBBYIST_FILING_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistFilingType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_LOBBYIST_FILING_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistFilingType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_LOBBYIST_STATUS_TYPE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistStatusType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_STATUS_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistStatusType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_RECORD_TYPE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistRecordType/GetById/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_LOBBYIST_RECORD_TYPE = (method, type, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistRecordType`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}
export const GET_SETTINGS_LOBBYIST_FILING_TYPE_IDS_BY_RECORD_TYPE = (options, recordTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistFilingTypeXref/GetFilingTypeXrefIdsByRecordType/${recordTypeId}`,
      method: 'GET',
      ...options,
    },
    callback,
    errorCallback
  )
}

export const SAVE_SETTINGS_LOBBYIST_FILING_TYPE_XREF = (method, xref, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistFilingTypeXref`,
      method,
      body: JSON.stringify(xref),
    },
    callback,
    errorCallback
  )
}


export const DELETE_SETTINGS_LOBBYIST_FILING_TYPE_XREF = (xrefId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistFilingTypeXref/${xrefId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}


export const GET_SETTINGS_LOBBYIST_XREF_BY_RECORD_TYPE_FILING_TYPE = (options, recordTypeId, filingTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LobbyistFilingTypeXref/GetFilingTypeXrefByRecordTypeFilingType/${recordTypeId}/${filingTypeId}`,
      method: 'GET',
      ...options
    },
    callback,
    errorCallback
  )
}
// #endregion

export const GET_SERVICE_OF_PROCESS_FILING_IS_APPROVED = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/ServiceOfProcess/FilingIsApproved/${filingNum}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const DELETE_SETTINGS_LOOKUPTYPE_BY_IDS = (controller, ids, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${controller}/DeleteByIds`,
      method: 'DELETE',
      body: JSON.stringify(ids),
    },
    callback,
    errorCallback
  )
}

export const GET_JOINT_VENTURE_ENTITIES = (groupId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/JointVentureEntities/${groupId}`,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

// #region Historic Secretary of State Setting
export const GET_ALL_HISTORIC_SOS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/HistoricSecretaryOfState/GetList`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_HISTORIC_SOS = (item, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/HistoricSecretaryOfState`,
      method,
      body: JSON.stringify(item),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_HISTORIC_SOS_SIGNATURE = (hsosId, file, callback, errorCallback) => {
  let opts = {}
  opts.body = getFormDataObject([file])
  let AUTH = localStorage.getItem('USER_AUTHENTICATION')
  let auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {}

  if (!auth.ID) {
    console.debug('unable to find user from local storage. Checking cookies...')

    let specialUserId = Cookies.get('special-user-id')

    if (specialUserId && specialUserId !== '') {
      console.debug('user found in cookies. attaching credentials')
      auth.ID = specialUserId
    }
  }

  new Promise((res, rej) => {
    var xhr = new XMLHttpRequest()
    xhr.open('POST', `${BASE_URL}/api/HistoricSecretaryOfState/UpdateSignature/${hsosId}`)
    xhr.setRequestHeader('Authorization', auth.ID)
    xhr.onload = (e) => res(e.target.responseText)
    xhr.onerror = rej
    xhr.send(opts.body)
  })
    .then(callback)
    .catch(errorCallback)
}

export const GET_HISTORIC_SOS_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/HistoricSecretaryOfState/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}
// #endregion

// #region Legacy Filing and Config
export const GET_LEGACY_FILING_CONFIG_SOURCE_TYPE_IDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LegacyFilingConfig/GetConfiguredSourceTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_LEGACY_FILING_CONFIG_BY_SOURCE_TYPE_ID = (
  sourceTypeId,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/LegacyFilingConfig/GetBySourceTypeId/${sourceTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const SUBMIT_LEGACY_FILING = (filingInfo, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/LegacyFiling/Submit`,
      method: 'POST',
      body: JSON.stringify(filingInfo),
    },
    callback,
    errorCallback
  )
}

// #endregion

// #region Record Access Setting
export const GET_ALL_RECORD_USER_ACCESS_ROLES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole/GetAll`, // UPDATE THIS to what is the match.
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_RECORD_USER_ACCESS_ROLE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole/GetById/${id}`, // UPDATE THIS to what is the match.
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_RECORD_USER_ACCESS_ROLE = (payload, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole`, // UPDATE THIS to what is the match.
      method,
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_REQUEST_ACCESS_CONFIGURED_SOURCE_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole/GetConfiguredSourceTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_MODULES_FOR_RECORD_ACCESS = (successCallback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccessUserRole/GetConfiguredMiscellaneousModules`,
      method: 'GET',
    },
    successCallback,
    errorCallback
  )
}
// #endregion

// #region North Dakota Login

export const ND_AUTH_SETTINGS_GET = (authType, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NdLogin/auth-settings?authType=${authType}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const ND_STATE_USER_GET = (accessToken, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NdLogin/state-user-get/${accessToken}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const ND_PUBLIC_USER_GET = (idToken, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/NdLogin/public-user-get/${idToken}"`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_PAYMENTUS_XOTP_URL = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Paymentus/GetXotpIframeUrl`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const PAY_WITH_PAYMENTUS_SAVED_PAYMENT_METHOD = (
  payload,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Paymentus/PayWithPaymentusSavedPaymentMethod`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_UID_CORP = (corpName, fien, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/uin/GetUinFromCompanyName/${corpName}/${fien}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_UID_INDIVIDUAL = (firstName, lastName, fien, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/uin/GetUinFromFullName/${firstName}/${lastName}/${fien}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

// #endregion

// #region Request Access
export const DOES_RECORD_HAVE_OWNER = (sourceTypeId, sourceId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/RecordHasOwner/${sourceTypeId}/${sourceId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const REQUEST_ACCESS_FROM_OWNER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/RequestAccessFromOwner`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const CREATE_REQUEST_ACCESS_PASSKEY = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/RequestPasskey`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const VERIFY_REQUEST_ACCESS_PASSKEY = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RecordAccess/VerifyPasskey`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}


// #endregion

// #region New Lists

export const GET_LIST_DETAILS_BY_CATEGORY = (category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Lists/Details/${category}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_LIST_TABLE_DATA = (category, selectedOption, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Lists/Results/${category}/${selectedOption}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

// #endregion

//#region Misc Records Field Definition Settings
// Confirm actual endpoint paths and DTO field names with backend before wiring real URLs.

// GET /api/MiscellaneousField/FieldDefinitionDataTypes
// Returns: string[] — e.g. ["String", "Int", "Bool", "Date", "DateTime", "LookupType", "Address", "Name", "PhoneNumber"]
export const getMiscRecordsFieldDataTypes = (successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousField/FieldDefinitionDataTypes`,
      method: 'GET',
    },
    successCb,
    errorCb
  )
}

// GET /api/MiscellaneousField/FieldDefinitions?moduleId={moduleId}
// Returns: { MiscellaneousFieldId, FieldDisplayName }[]
export const getMiscRecordsFieldDefinitions = (moduleId, successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousField/FieldDefinitions?moduleId=${moduleId}`,
      method: 'GET',
    },
    successCb,
    errorCb
  )
}

// GET /api/MiscellaneousField/FieldDefinitions/{miscellaneousFieldId}
// Returns: { MiscellaneousFieldId, MiscellaneousModuleId, FieldName, FieldDisplayName, DataType,
//   IsStaffSearchable, ShowInStaffSearchGrid, IsPublicSearchable, DisplayOnPublicSlideOut,
//   ShowInPublicSearchGrid, IsMyRecordsFilter, DisplayOnRecordDetail, LookupTypeValues,
//   IsServerDropdownOption, IsEncrypted, TrackChangesInHistory, ShowInPublicHistory,
//   ConfigurableAsFilingRequirement, ConfigurableAsFilingResult, IsDeleted,
//   LastModifiedByUserId, LastModifiedByUser, LastModifiedByDate }
export const getMiscRecordsFieldDefinition = (miscellaneousFieldId, successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousField/FieldDefinitions/${miscellaneousFieldId}`,
      method: 'GET',
    },
    successCb,
    errorCb
  )
}

// POST /api/MiscellaneousField/FieldDefinitions — creates a new field definition
// PUT  /api/MiscellaneousField/FieldDefinitions — updates an existing field definition
// Payload shape mirrors the full field definition DTO (see getMiscRecordsFieldDefinition above)
export const saveMiscRecordsFieldDefinition = (method, payload, successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousField/FieldDefinitions`,
      method,
      body: JSON.stringify(payload),
    },
    successCb,
    errorCb
  )
}

// DELETE /api/MiscellaneousField/FieldDefinitions/{miscellaneousFieldId}
// Soft-deletes: sets IsDeleted = true server-side
export const deleteMiscRecordsFieldDefinition = (miscellaneousFieldId, successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousField/FieldDefinitions/${miscellaneousFieldId}`,
      method: 'DELETE',
    },
    successCb,
    errorCb
  )
}
//#endregion
export const GET_MISCELLANEOUS_MODULES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousModule`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISCELLANEOUS_MODULE_BY_ID = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousModule/${id}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_MISCELLANEOUS_MODULE = (type, method, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousModule`,
      method,
      body: JSON.stringify(type),
    },
    callback,
    errorCallback
  )
}

export const GET_MISCELLANEOUS_MODULE_FILING_TYPES = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

//#region Misc Records Filing Type Settings

export const GET_MISC_RECORDS_FILING_TYPES_BY_MODULE = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType/Details/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_RECORDS_FILING_TYPE_BY_ID = (filingTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType/Single/${filingTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_JOB_FREQUENCY_TYPES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType/JobFrequencyTypes`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_RECORDS_FILING_TYPE_FIELD_DETAILS = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousField/FilingFieldDetails?moduleId=${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CREATE_MISC_RECORDS_FILING_TYPE = (dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType`,
      method: 'POST',
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

export const UPDATE_MISC_RECORDS_FILING_TYPE = (filingTypeId, dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType/${filingTypeId}`,
      method: 'PUT',
      body: JSON.stringify(dto),
      },
    callback,
    errorCallback
  )
}

export const GET_APP_REPORTS_BY_CATEGORY_SOURCE_TYPE_ID = (sourceTypeId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppReport/GetAppReportsByCategorySourceTypeId/${sourceTypeId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_GENERATED_EMAIL_OPTIONS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousFilingType/GetGeneratedEmailOptions`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

//#endregion

// #region Miscellaneous Records Forms Manager

export const GET_MISC_FORMS_MANAGER_PAGE = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_SETTINGS_FORMS = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousSettingsForms/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_FORMS_PAGE = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/forms/miscellaneous/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_PAPER_INITIAL_FILING_FORMS = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/forms/miscellaneous/PaperInitialFilingForms/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_PAPER_AMENDMENT_FORMS = (moduleId, recordId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/forms/miscellaneous/PaperAmendmentForms/${moduleId}?recordId=${recordId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CREATE_MISC_FORM_CATEGORY = (moduleId, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/category/${moduleId}`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const PUBLISH_MISC_FORM_CATEGORY = (moduleId, categoryId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/category/publish/${moduleId}/${categoryId}`,
      method: 'PATCH',
    },
    callback,
    errorCallback
  )
}

export const UNPUBLISH_MISC_FORM_CATEGORY = (moduleId, categoryId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/category/unpublish/${moduleId}/${categoryId}`,
      method: 'PATCH',
    },
    callback,
    errorCallback
  )
}

export const MOVE_MISC_FORM_CATEGORY = (moduleId, categoryId, moveUp, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/category/move/${moduleId}/${categoryId}/${moveUp}`,
      method: 'PATCH',
    },
    callback,
    errorCallback
  )
}

export const RENAME_MISC_FORM_CATEGORY = (categoryId, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/category/rename/${categoryId}`,
      method: 'PATCH',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const DELETE_MISC_FORM_CATEGORY = (moduleId, categoryId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/category/${moduleId}/${categoryId}`,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const MOVE_MISC_FORM = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/form/move`,
      method: 'PATCH',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const IMPORT_MISC_FORM = (preserveId, moduleId, categoryId, fileBody, callback, errorCallback) => {
  const encoded = window.btoa(utf8.encode(JSON.stringify(fileBody)))
  const blob = new Blob([encoded], { type: 'text/plain' })
  const formData = new FormData()
  formData.append('file', blob, 'wizard.txt')
  const url = categoryId != null
    ? `/api/FormsManager/miscellaneous/import/${preserveId}/${moduleId}/${categoryId}`
    : `/api/FormsManager/miscellaneous/import/${preserveId}/${moduleId}`
  fetchAndCatch(
    {
      url,
      method: 'POST',
      body: formData,
      contentType: 'text/plain',
    },
    callback,
    errorCallback
  )
}

export const ARCHIVE_MISC_FORM = (moduleId, categoryId, formDefinitionId, callback, errorCallback) => {
  const url = categoryId != null
    ? `/api/FormsManager/miscellaneous/archive/${moduleId}/${categoryId}/${formDefinitionId}`
    : `/api/FormsManager/miscellaneous/archive/${moduleId}/${formDefinitionId}`
  fetchAndCatch(
    {
      url,
      method: 'DELETE',
    },
    callback,
    errorCallback
  )
}

export const CHECK_MISC_FORM_ID_IN_USE = (formDefinitionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/check-form-id-in-use/${formDefinitionId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const CLONE_MISC_FORM = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/clone`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const LOAD_MISC_WIZARD = (formDefinitionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/form/${formDefinitionId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const UPDATE_MISC_FORMS_ICON = (moduleId, icon, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormsManager/miscellaneous/icon/${moduleId}`,
      method: 'PATCH',
      body: JSON.stringify({ NewIcon: icon }),
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_WIZARD_REVISION_HISTORY = (formDefinitionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormRevision/${formDefinitionId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_WIZARD_REVISION_STEPS = (formDefinitionId, revisionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormRevision/${formDefinitionId}/${revisionId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const APPLY_MISC_WIZARD_REVISION = (formDefinitionId, revisionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormRevision/apply/${formDefinitionId}/${revisionId}`,
      method: 'PUT',
    },
    callback,
    errorCallback
  )
}

// #endregion

// #region Miscellaneous Records Work Queue

export const GET_MISC_RECORDS_WORK_QUEUE_ITEMS = (moduleId, parameters, requestId, callback, errorCallback) => {
  const queryString = Object.entries(parameters)
    .filter(function(entry) { return entry[1] !== null && entry[1] !== undefined && entry[1] !== '' })
    .map(function(entry) { return encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) })
    .join('&')
  fetchAndCatch(
    {
      url: queryString
        ? '/api/Miscellaneous/WorkQueue/' + moduleId + '?' + queryString
        : '/api/Miscellaneous/WorkQueue/' + moduleId,
      method: 'GET',
      auth: true,
      requestId,
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_FILING_REPORTS = (filingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/Report/' + filingId,
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}
// #endregion

// #region Misc Record Detail Config

export const getMiscRecordDetailConfig = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousRecordDetails/GetRecordDetailConfig/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const getMiscRecordDetailAvailableFields = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousRecordDetails/GetRecordDetailAvailableFields/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const saveMiscRecordDetailConfig = (dto, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousRecordDetails/SaveRecordDetailConfig`,
      method: 'POST',
      body: JSON.stringify(dto),
    },
    callback,
    errorCallback
  )
}

// #endregion

// #region Misc Record Details

export const getMiscRecordDetails = (miscellaneousRecordId, successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousRecordDetails/GetRecordDetails/${miscellaneousRecordId}`,
      method: 'GET',
    },
    successCb,
    errorCb
  )
}

export const getMiscRecordFilingHistory = (miscellaneousRecordId, successCb, errorCb) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousRecordDetails/GetFilingHistory/${miscellaneousRecordId}`,
      method: 'GET',
    },
    successCb,
    errorCb
  )
}

// #endregion

// #region Miscellaneous Records Public Search

export const GET_MISC_PUBLIC_SEARCH_TEMPLATE = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/PublicSearch/Template/' + moduleId,
      method: 'GET',
      auth: false,
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_PUBLIC_SEARCH_RESULTS = (moduleId, parameters, requestId, callback, errorCallback) => {
  const queryString = Object.entries(parameters)
    .filter(function(entry) { return entry[1] !== null && entry[1] !== undefined && entry[1] !== '' })
    .map(function(entry) { return encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) })
    .join('&')
  fetchAndCatch(
    {
      url: queryString
        ? '/api/Miscellaneous/PublicSearch/' + moduleId + '?' + queryString
        : '/api/Miscellaneous/PublicSearch/' + moduleId,
      method: 'GET',
      auth: false,
      requestId,
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_PAPER_SEARCH_TEMPLATE = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/PublicSearch/PaperProcessTemplate/' + moduleId, // TODO: confirm with backend
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_PAPER_PROCESS_SEARCH_RESULTS = (moduleId, filterValues, recordNum, callback, errorCallback) => {
  const params = Object.entries(filterValues)
    .filter(function(entry) { return entry[1] !== null && entry[1] !== undefined && entry[1] !== '' })
    .map(function(entry) { return encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) })
  if (recordNum !== null && recordNum !== undefined && recordNum !== '') {
    params.push('recordNum=' + encodeURIComponent(recordNum))
  }
  const queryString = params.join('&')
  fetchAndCatch(
    {
      url: queryString
        ? '/api/Miscellaneous/PublicSearch/PaperProcess/' + moduleId + '?' + queryString
        : '/api/Miscellaneous/PublicSearch/PaperProcess/' + moduleId,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_RECORD_DRAWER = (recordId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/PublicDetail/' + recordId,
      method: 'GET',
      auth: false,
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_RECORD_AMENDMENTS = (recordId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/PublicDetail/' + recordId + '/Amendments',
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_RECORD_ORDER_FILINGS = (recordId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/PublicDetail/' + recordId + '/OrderFilings',
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_PUBLIC_FILING_HISTORY = (recordNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Miscellaneous/PublicDetail/' + recordNum + '/FilingHistory',
      method: 'GET',
      auth: true,
    },
    callback,
    errorCallback
  )
}


export const GET_MISC_MY_RECORDS = (moduleId, parameters, requestId, callback, errorCallback) => {
  const queryString = Object.entries(parameters)
    .filter(function(entry) { return entry[1] !== null && entry[1] !== undefined && entry[1] !== '' })
    .map(function(entry) { return encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) })
    .join('&')
  fetchAndCatch(
    {
      url: queryString
        ? '/api/Miscellaneous/GetMyRecords/' + moduleId + '?' + queryString
        : '/api/Miscellaneous/GetMyRecords/' + moduleId,
      method: 'GET',
      auth: true,
      requestId,
    },
    callback,
    errorCallback
  )
}

// #endregion

// #region Misc Staff Search

export const GET_MISC_STAFF_SEARCH_FIELDS = (moduleId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousStaffSearch/GetSearchFields/${moduleId}`,
      method: 'GET',
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_STAFF_SEARCH = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousStaffSearch/Search`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

export const GET_MISC_STAFF_SEARCH_CSV_RESULTS = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MiscellaneousStaffSearch/SearchCsvResults`,
      method: 'POST',
      body: JSON.stringify(payload),
    },
    callback,
    errorCallback
  )
}

// #endregion
